import ScratchBlocks from 'scratch-blocks';

import {
    toPython
} from './libraries/python.js';
import {
    toC
} from './libraries/c.js';
import {
    toPythonDebug
} from './libraries/PythonDebug.js';
import E7Blocks from './libraries/blocks/E7Blocks.js';


function BoxD() {
    this.gt = {
        svg: "image/svg+xml",
        png: "image/png",
        jpg: "image/jpeg",
        jpeg: "image/jpeg"
    }
    this.dataURLtoBlob = (dataurl) => {
        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], {
            type: mime
        });
    }
    this.ht = (e, t, A) => new Promise((n, o) => {
        const r = new Image;
        r.crossOrigin = "Anonymous";
        r.onload = () => {
            const e = document.createElement("canvas"),
                i = e.getContext("2d");
            e.width = t || r.width * 2
            e.height = A || r.height * 2
            i.fillStyle = "rgba(0, 0, 0, 0)"
            i.fillRect(0, 0, e.width, e.height)
            i.drawImage(r, 0, 0, r.width * 2, r.height * 2);
            try {
                const t = e.toDataURL("image/png", 1.0);
                let base64 = URL.createObjectURL(this.dataURLtoBlob(t))
                n(base64)
            } catch (e) {
                o(e)
            }
        };
        r.onerror = e => {
            o(e)
        };
        r.src = e
    })
    this.dt = e => {
        const t = e.querySelectorAll("image"),
            A = [];
        return t.forEach(e => {
            const t = e.href.baseVal;
            A.push((e => {
                if (0 === e.indexOf("data:")) return Promise.resolve(e);
                let t;
                return fetch(e, {
                    mode: "cors"
                }).then(A => {
                    if (t = A.headers.get("Content-Type"), t = t && t.split(";")[0], !t) {
                        const A = e.match(/.(png|svg|jpe?g)$/);
                        A && (t = this.gt[A[1]] || "image/png")
                    }
                    return A.arrayBuffer()
                }).then(e => {
                    const A = function (e) {
                        let t = "";
                        const A = new Uint8Array(e),
                            n = A.byteLength;
                        for (let e = 0; e < n; e++) t += String.fromCharCode(A[e]);
                        return window.btoa(t)
                    }(e);
                    return `data:${t};base64,${A}`
                })
            })(t).then(t => (e.href.baseVal = t, e)).catch(t => {
                e.href.baseVal = ""
            }))
        }), Promise.all(A)
    }
    this.mt = e => {
        const t = document.createElement("a");
        let blockNum = sessionStorage.getItem("blockNum")
        if (!blockNum) {
            blockNum = 0
        }

        blockNum = Number(blockNum) + 1
        document.body.appendChild(t)
        t.href = e
        t.download = `blocks${blockNum}`
        t.click()
        window.URL.revokeObjectURL(e)
        // document.body.removeChild(t)
        sessionStorage.setItem("blockNum", blockNum)
    }
    this.ft = (e, t) => {
        const A = window.workspace.getMainWorkspace().getBlockById(e),
            o = A.getSvgRoot().cloneNode(!0);
        if (t) {
            const e = o.querySelectorAll(".scratchblocksDraggable"),
                t = e => /argument|reporter/g.test(e);
            for (const A of e) t(A.getAttribute("data-shapes")) || A.remove()
        }
        return new Promise(e => {
            setTimeout(() => {
                o.innerHTML = o.innerHTML.replace(/&nbsp;/g, " ")
                o.removeAttribute("filter")
                o.querySelectorAll("[fill]").forEach(e => {
                    if (-1 !== e.getAttribute("fill").indexOf("url(#scratchblocksDisabledPattern")) {
                        e.setAttribute("fill", "#aaa")
                        e.setAttribute("fill-opacity", "0.5")
                    }
                });
                const t = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                t.appendChild(o)
                document.body.appendChild(t);
                const n = 10 + (o.getAttribute("data-shapes").indexOf("hat") > -1 ? 16 : 0);
                o.setAttribute("transform", `translate(10 ${n})`);
                const r = o.getBoundingClientRect(),
                    i = r.width + 20,
                    a = r.height + 20;
                t.setAttribute("width", i)
                t.setAttribute("height", a)
                A.RTL && t.setAttribute("viewBox", `-${i - 20} 0 ${i} ${a}`)
                this.pt(t, {
                    recursive: !0,
                    properties: ["fill", "font-family", "font-size", "font-weight"]
                });
                this.dt(t).then(() => {
                    const A = (new XMLSerializer).serializeToString(t);
                    t.parentNode.removeChild(t)
                    e(`data:image/svg+xml;utf-8,${encodeURIComponent(A)}`)
                })
            }, 10)
        })
    }
    this.ar = Array.prototype.forEach
    this.pt = (n, i) => {
        var a, r;
        var then = this
        if (!n) throw new Error("No element specified.");
        i.recursive && (r = n.children, this.ar).call(r, (function (e) {
            then.pt(e, i)
        }));
        var o = getComputedStyle(n);
        (a = i.properties || o, this.ar).call(a, (function (t) {
            n.style[t] = o.getPropertyValue(t)
        }))
    }
    this.Et = () => {
        const e = window.workspace.getTopBlocks(),
            t = window.workspace.svgBlockCanvas_;
        let A = 1;
        const o = t.transform.baseVal;
        for (let e = 0; e < o.numberOfItems; e++) {
            const t = o.getItem(e);
            if (3 === t.type) {
                A = t.matrix.a;
                break
            }
        }
        const r = e.map(e => {
            const t = e.getSvgRoot().cloneNode(!0);
            // t.innerHTML = t.innerHTML.replace(/&nbsp;/g, " ")
            t.removeAttribute("filter")
            t.querySelectorAll("[fill]").forEach(e => {
                if (-1 !== e.getAttribute("fill").indexOf("url(#scratchblocksDisabledPattern")) {
                    e.setAttribute("fill", "#aaa")
                    e.setAttribute("fill-opacity", "0.5")
                }
            })
            return t
        });
        return new Promise(e => {
            setTimeout(() => {
                const o = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                let i = null;
                const a = {
                    x: 0,
                    y: 0
                };
                r.forEach(e => {
                    o.appendChild(e);
                    const t = 10 + (e.getAttribute("data-shapes").indexOf("hat") > -1 ? 16 : 0),
                        A = e.transform.baseVal;
                    let n = null;
                    for (let e = 0; e < A.numberOfItems; e++) {
                        const t = A.getItem(e);
                        2 === t.type && (n = t.matrix)
                    }
                    let r = {
                        e: 0,
                        f: 0
                    };
                    if (i && n) {
                        r = n.translate(-i.e, -i.f)
                        if (r.e < a.x) {
                            a.x = r.e
                        }
                        if (r.f < a.y) {
                            a.y = r.f
                        }
                    } else {
                        i = n
                    }
                    e.setAttribute("transform", `translate(${10 + r.e} ${t + r.f})`)

                })
                var tempDom = document.createElement('div')
                tempDom.setAttribute('style', 'width:100vw;height:100vh;overflow:hidden;position:absolute;z-index:-1')
                tempDom.appendChild(o)
                document.body.appendChild(tempDom);
                const s = t.getBoundingClientRect(),
                    l = s.width / A + 20,
                    c = s.height / A + 20;
                o.setAttribute("width", l)
                o.setAttribute("height", c)
                o.setAttribute("viewBox", `${a.x} ${a.y} ${l} ${c}`)
                window.workspace.RTL && o.setAttribute("viewBox", `-${l - 20} ${a.y} ${l} ${c}`)
                this.pt(o, {
                    recursive: !0,
                    properties: ["fill", "font-family", "font-size", "font-weight"]
                })
                this.dt(o).then(() => {
                    const t = (new XMLSerializer).serializeToString(o);
                    tempDom.parentNode.removeChild(tempDom)
                    e(`data:image/svg+xml;utf-8,${encodeURIComponent(t)}`)
                })
            }, 10)
        })
    }
    this.Mt = () => this.Et().then(e => {
        return this.ht(e)
    }).then(this.mt);
}

/**
 * Connect scratch blocks with the vm
 * @param {VirtualMachine} vm - The scratch vm
 * @return {ScratchBlocks} ScratchBlocks connected with the vm
 */
export default function (vm) {

    const jsonForMenuBlock = function (name, menuOptionsFn, colors, start) {
        return {
            message0: '%1',
            args0: [{
                type: 'field_dropdown',
                name: name,
                options: function () {
                    return start.concat(menuOptionsFn());
                }
            }],
            inputsInline: true,
            output: 'String',
            colour: colors.secondary,
            colourSecondary: colors.secondary,
            colourTertiary: colors.tertiary,
            outputShape: ScratchBlocks.OUTPUT_SHAPE_ROUND
        };
    };

    const jsonForHatBlockMenu = function (hatName, name, menuOptionsFn, colors, start) {
        return {
            message0: hatName,
            args0: [{
                type: 'field_dropdown',
                name: name,
                options: function () {
                    return start.concat(menuOptionsFn());
                }
            }],
            colour: colors.primary,
            colourSecondary: colors.secondary,
            colourTertiary: colors.tertiary,
            extensions: ['shape_hat']
        };
    };


    const jsonForSensingMenus = function (menuOptionsFn) {
        return {
            message0: ScratchBlocks.Msg.SENSING_OF,
            args0: [{
                    type: 'field_dropdown',
                    name: 'PROPERTY',
                    options: function () {
                        return menuOptionsFn();
                    }

                },
                {
                    type: 'input_value',
                    name: 'OBJECT'
                }
            ],
            output: true,
            colour: ScratchBlocks.Colours.sensing.primary,
            colourSecondary: ScratchBlocks.Colours.sensing.secondary,
            colourTertiary: ScratchBlocks.Colours.sensing.tertiary,
            outputShape: ScratchBlocks.OUTPUT_SHAPE_ROUND
        };
    };

    const soundsMenu = function () {
        let menu = [
            ['', '']
        ];
        if (vm.editingTarget && vm.editingTarget.sprite.sounds.length > 0) {
            menu = vm.editingTarget.sprite.sounds.map(sound => [sound.name, sound.name]);
        }
        menu.push([
            ScratchBlocks.ScratchMsgs.translate('SOUND_RECORD', 'record...'),
            ScratchBlocks.recordSoundCallback
        ]);
        return menu;
    };

    const costumesMenu = function () {
        if (vm.editingTarget && vm.editingTarget.getCostumes().length > 0) {
            return vm.editingTarget.getCostumes().map(costume => [costume.name, costume.name]);
        }
        return [
            ['', '']
        ];
    };

    const backdropsMenu = function () {
        const next = ScratchBlocks.ScratchMsgs.translate('LOOKS_NEXTBACKDROP', 'next backdrop');
        const previous = ScratchBlocks.ScratchMsgs.translate('LOOKS_PREVIOUSBACKDROP', 'previous backdrop');
        const random = ScratchBlocks.ScratchMsgs.translate('LOOKS_RANDOMBACKDROP', 'random backdrop');
        if (vm.runtime.targets[0] && vm.runtime.targets[0].getCostumes().length > 0) {
            return vm.runtime.targets[0].getCostumes().map(costume => [costume.name, costume.name])
                .concat([
                    [next, 'next backdrop'],
                    [previous, 'previous backdrop'],
                    [random, 'random backdrop']
                ]);
        }
        return [
            ['', '']
        ];
    };

    const backdropNamesMenu = function () {
        const stage = vm.runtime.getTargetForStage();
        if (stage && stage.getCostumes().length > 0) {
            return stage.getCostumes().map(costume => [costume.name, costume.name]);
        }
        return [
            ['', '']
        ];
    };

    const spriteMenu = function () {
        const sprites = [];
        for (const targetId in vm.runtime.targets) {
            if (!vm.runtime.targets.hasOwnProperty(targetId)) continue;
            if (vm.runtime.targets[targetId].isOriginal) {
                if (!vm.runtime.targets[targetId].isStage && !vm.runtime.targets[targetId].isRobot) {
                    if (vm.runtime.targets[targetId] === vm.editingTarget) {
                        continue;
                    }
                    sprites.push([vm.runtime.targets[targetId].sprite.name, vm.runtime.targets[targetId].sprite.name]);
                }
            }
        }
        return sprites;
    };

    const cloneMenu = function () {
        if (vm.editingTarget && vm.editingTarget.isStage) {
            const menu = spriteMenu();
            if (menu.length === 0) {
                return [
                    ['', '']
                ]; // Empty menu matches Scratch 2 behavior
            }
            return menu;
        }
        const myself = ScratchBlocks.ScratchMsgs.translate('CONTROL_CREATECLONEOF_MYSELF', 'myself');
        return [
            [myself, '_myself_']
        ].concat(spriteMenu());
    };

    const soundColors = ScratchBlocks.Colours.sounds;

    const looksColors = ScratchBlocks.Colours.looks;

    const motionColors = ScratchBlocks.Colours.motion;

    const sensingColors = ScratchBlocks.Colours.sensing;

    const controlColors = ScratchBlocks.Colours.control;

    const eventColors = ScratchBlocks.Colours.event;

    ScratchBlocks.Blocks.sound_sounds_menu.init = function () {
        const json = jsonForMenuBlock('SOUND_MENU', soundsMenu, soundColors, []);
        this.jsonInit(json);
    };

    ScratchBlocks.Blocks.looks_costume.init = function () {
        const json = jsonForMenuBlock('COSTUME', costumesMenu, looksColors, []);
        this.jsonInit(json);
    };

    ScratchBlocks.Blocks.looks_backdrops.init = function () {
        const json = jsonForMenuBlock('BACKDROP', backdropsMenu, looksColors, []);
        this.jsonInit(json);
    };

    ScratchBlocks.Blocks.event_whenbackdropswitchesto.init = function () {
        const json = jsonForHatBlockMenu(
            ScratchBlocks.Msg.EVENT_WHENBACKDROPSWITCHESTO,
            'BACKDROP', backdropNamesMenu, eventColors, []);
        this.jsonInit(json);
    };

    ScratchBlocks.Blocks.motion_pointtowards_menu.init = function () {
        const mouse = ScratchBlocks.ScratchMsgs.translate('MOTION_POINTTOWARDS_POINTER', 'mouse-pointer');
        const json = jsonForMenuBlock('TOWARDS', spriteMenu, motionColors, [
            [mouse, '_mouse_']
        ]);
        this.jsonInit(json);
    };

    ScratchBlocks.Blocks.motion_goto_menu.init = function () {
        const random = ScratchBlocks.ScratchMsgs.translate('MOTION_GOTO_RANDOM', 'random position');
        const mouse = ScratchBlocks.ScratchMsgs.translate('MOTION_GOTO_POINTER', 'mouse-pointer');
        const json = jsonForMenuBlock('TO', spriteMenu, motionColors, [
            [random, '_random_'],
            [mouse, '_mouse_']
        ]);
        this.jsonInit(json);
    };

    ScratchBlocks.Blocks.motion_glideto_menu.init = function () {
        const random = ScratchBlocks.ScratchMsgs.translate('MOTION_GLIDETO_RANDOM', 'random position');
        const mouse = ScratchBlocks.ScratchMsgs.translate('MOTION_GLIDETO_POINTER', 'mouse-pointer');
        const json = jsonForMenuBlock('TO', spriteMenu, motionColors, [
            [random, '_random_'],
            [mouse, '_mouse_']
        ]);
        this.jsonInit(json);
    };

    ScratchBlocks.Blocks.sensing_of_object_menu.init = function () {
        const stage = ScratchBlocks.ScratchMsgs.translate('SENSING_OF_STAGE', 'Stage');
        const json = jsonForMenuBlock('OBJECT', spriteMenu, sensingColors, [
            [stage, '_stage_']
        ]);
        this.jsonInit(json);
    };

    ScratchBlocks.Blocks.sensing_of.init = function () {
        const blockId = this.id;
        // Function that fills in menu for the first input in the sensing block.
        // Called every time it opens since it depends on the values in the other block input.
        const menuFn = function () {
            const stageOptions = [
                [ScratchBlocks.Msg.SENSING_OF_BACKDROPNUMBER, 'backdrop #'],
                [ScratchBlocks.Msg.SENSING_OF_BACKDROPNAME, 'backdrop name'],
                [ScratchBlocks.Msg.SENSING_OF_VOLUME, 'volume']
            ];
            const spriteOptions = [
                [ScratchBlocks.Msg.SENSING_OF_XPOSITION, 'x position'],
                [ScratchBlocks.Msg.SENSING_OF_YPOSITION, 'y position'],
                [ScratchBlocks.Msg.SENSING_OF_DIRECTION, 'direction'],
                [ScratchBlocks.Msg.SENSING_OF_COSTUMENUMBER, 'costume #'],
                [ScratchBlocks.Msg.SENSING_OF_COSTUMENAME, 'costume name'],
                [ScratchBlocks.Msg.SENSING_OF_SIZE, 'size'],
                [ScratchBlocks.Msg.SENSING_OF_VOLUME, 'volume']
            ];
            if (vm.editingTarget) {
                let lookupBlocks = vm.editingTarget.blocks;
                let sensingOfBlock = lookupBlocks.getBlock(blockId);

                // The block doesn't exist, but should be in the flyout. Look there.
                if (!sensingOfBlock) {
                    sensingOfBlock = vm.runtime.flyoutBlocks.getBlock(blockId);
                    // If we still don't have a block, just return an empty list . This happens during
                    // scratch blocks construction.
                    if (!sensingOfBlock) {
                        return [
                            ['', '']
                        ];
                    }
                    // The block was in the flyout so look up future block info there.
                    lookupBlocks = vm.runtime.flyoutBlocks;
                }
                // Get all the stage variables (no lists) so we can add them to menu when the stage is selected.
                const stageVariableOptions = vm.runtime.getTargetForStage().getAllVariableNamesInScopeByType('');
                const stageVariableMenuItems = stageVariableOptions.map(variable => [variable, variable]);
                if (sensingOfBlock.inputs.OBJECT.shadow !== sensingOfBlock.inputs.OBJECT.block) {
                    // There's a block dropped on top of the menu. It'd be nice to evaluate it and
                    // return the correct list, but that is tricky. Scratch2 just returns stage options
                    // so just do that here too.
                    return stageOptions.concat(stageVariableMenuItems);
                }
                const menuBlock = lookupBlocks.getBlock(sensingOfBlock.inputs.OBJECT.shadow);
                const selectedItem = menuBlock.fields.OBJECT.value;
                if (selectedItem === '_stage_') {
                    return stageOptions.concat(stageVariableMenuItems);
                }
                // Get all the local variables (no lists) and add them to the menu.
                const target = vm.runtime.getSpriteTargetByName(selectedItem);
                let spriteVariableOptions = [];
                // The target should exist, but there are ways for it not to (e.g. #4203).
                if (target) {
                    spriteVariableOptions = target.getAllVariableNamesInScopeByType('', true);
                }
                const spriteVariableMenuItems = spriteVariableOptions.map(variable => [variable, variable]);
                return spriteOptions.concat(spriteVariableMenuItems);
            }
            return [
                ['', '']
            ];
        };

        const json = jsonForSensingMenus(menuFn);
        this.jsonInit(json);
    };

    ScratchBlocks.Blocks.sensing_distancetomenu.init = function () {
        const mouse = ScratchBlocks.ScratchMsgs.translate('SENSING_DISTANCETO_POINTER', 'mouse-pointer');
        const json = jsonForMenuBlock('DISTANCETOMENU', spriteMenu, sensingColors, [
            [mouse, '_mouse_']
        ]);
        this.jsonInit(json);
    };

    ScratchBlocks.Blocks.sensing_touchingobjectmenu.init = function () {
        const mouse = ScratchBlocks.ScratchMsgs.translate('SENSING_TOUCHINGOBJECT_POINTER', 'mouse-pointer');
        const edge = ScratchBlocks.ScratchMsgs.translate('SENSING_TOUCHINGOBJECT_EDGE', 'edge');
        const json = jsonForMenuBlock('TOUCHINGOBJECTMENU', spriteMenu, sensingColors, [
            [mouse, '_mouse_'],
            [edge, '_edge_']
        ]);
        this.jsonInit(json);
    };

    ScratchBlocks.Blocks.control_create_clone_of_menu.init = function () {
        const json = jsonForMenuBlock('CLONE_OPTION', cloneMenu, controlColors, []);
        this.jsonInit(json);
    };

    ScratchBlocks.VerticalFlyout.getCheckboxState = function (blockId) {
        const monitoredBlock = vm.runtime.monitorBlocks._blocks[blockId];
        return monitoredBlock ? monitoredBlock.isMonitored : false;
    };

    ScratchBlocks.FlyoutExtensionCategoryHeader.getExtensionState = function (extensionId) {
        if (vm.getPeripheralIsConnected(extensionId)) {
            return ScratchBlocks.StatusButtonState.READY;
        }
        return ScratchBlocks.StatusButtonState.NOT_READY;
    };

    ScratchBlocks.FieldNote.playNote_ = function (noteNum, extensionId) {
        vm.runtime.emit('PLAY_NOTE', noteNum, extensionId);
    };
    ScratchBlocks.BoxD = BoxD

    // ===============================================================================================



    ScratchBlocks.Blocks.data_setlist = {
        init: function () {
            this.jsonInit({
                message0: "将 %1 设为 %2",
                args0: [{
                    type: "field_variable",
                    name: "LIST",
                    variableTypes: [ScratchBlocks.LIST_VARIABLE_TYPE]
                }, {
                    type: "input_value",
                    name: "VALUE"
                }],
                category: ScratchBlocks.Categories.dataLists,
                extensions: ["colours_data_lists", "shape_statement"]
            })
        }
    };
    ScratchBlocks.Blocks.AI_isSimplePoseBy = {
        init: function () {
            this.jsonInit({
                message0: "人体姿态识别结果为 %1",
                args0: [{
                    type: "field_dropdown",
                    name: "RESULT",
                    options: [
                        ["V字型", "V字型"],
                        ["正常型", "正常型"],
                        ["大字型", "大字型"]
                    ]
                }],
                colour: "#DA70D6",
                extensions: ["output_boolean"]
            })
        }
    }


    ScratchBlocks.Blocks.AI_getVoiceData = {
        init: function () {
            this.jsonInit({
                message0: "百度api语音识别结果",
                colour: "#DA70D6",
                extensions: ["output_number"]
            })
        }
    }

    ScratchBlocks.Blocks.AI_isAiData = {
        init: function () {
            this.jsonInit({
                message0: "AI识别结果为 %1 ?",
                args0: [{
                    type: "input_value",
                    name: "RESULT",
                }],
                colour: "#DA70D6",
                extensions: ["output_boolean"]
            })
        }
    };

    ScratchBlocks.Blocks.AI_getLeft = {
        init: function () {
            this.jsonInit({
                message0: "出左拳？",
                colour: "#DA70D6",
                extensions: ["output_boolean"]
            })
        }
    };
    ScratchBlocks.Blocks.AI_getRight = {
        init: function () {
            this.jsonInit({
                message0: "出右拳？",
                colour: "#DA70D6",
                extensions: ["output_boolean"]
            })
        }
    };
    ScratchBlocks.Blocks.AI_getShipSpeed = {
        init: function () {
            this.jsonInit({
                message0: "龙舟速度",
                colour: "#DA70D6",
                extensions: ["output_number"]
            })
        }
    };
    ScratchBlocks.Blocks.AI_isShipForward = {
        init: function () {
            this.jsonInit({
                message0: "龙舟是否前进？",
                colour: "#DA70D6",
                extensions: ["output_boolean"]
            })
        }
    };
    ScratchBlocks.Blocks.AI_isShipBack = {
        init: function () {
            this.jsonInit({
                message0: "龙舟是否后退？",
                colour: "#DA70D6",
                extensions: ["output_boolean"]
            })
        }
    };







    ScratchBlocks.Blocks.E7_getPressureData = {
        init: function () {
            this.jsonInit({
                message0: "气压传感器 %1 数值",
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "output_number"]
            })
        }
    };

    ScratchBlocks.Blocks.E7_getVoiceData = {
        init: function () {
            this.jsonInit({
                message0: "声敏传感器 %1 数值",
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "output_number"]
            })
        }
    };

    ScratchBlocks.Blocks.E7_getTSDData = {
        init: function () {
            this.jsonInit({
                message0: "土壤湿度传感器 %1 数值",
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "output_number"]
            })
        }
    };

    ScratchBlocks.Blocks.E7_getWDData = {
        init: function () {
            this.jsonInit({
                message0: "温度传感器 %1 数值",
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "output_number"]
            })
        }
    };

    ScratchBlocks.Blocks.E7_getSDData = {
        init: function () {
            this.jsonInit({
                message0: "湿度传感器 %1 数值",
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "output_number"]
            })
        }
    };


    ScratchBlocks.Blocks.E7_getYDData = {
        init: function () {
            this.jsonInit({
                message0: "雨滴传感器 %1 数值",
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "output_number"]
            })
        }
    };

    ScratchBlocks.Blocks.E7_getAirQualityData = {
        init: function () {
            this.jsonInit({
                message0: "空气质量传感器 %1 数值",
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "output_number"]
            })
        }
    };


    ScratchBlocks.Blocks.E7_getRFIDNum = {
        init: function () {
            this.jsonInit({
                message0: "读RFID卡号 %1",
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "output_number"]
            })
        }
    };

    ScratchBlocks.Blocks.E7_getRFIDData = {
        init: function () {
            this.jsonInit({
                message0: "读RFID卡数据 %1",
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "output_number"]
            })
        }
    };

    ScratchBlocks.Blocks.E7_setRFIDData = {
        init: function () {
            this.jsonInit({
                message0: "写RFID卡数据 %1 %2",
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "input_value",
                    name: "VALUE",
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "shape_statement"]
            })
        }
    };


    ScratchBlocks.Blocks.E7_setAttitudeModel = {
        init: function () {
            this.jsonInit({
                message0: "姿态传感器 %1",
                args0: [{
                    type: "field_dropdown",
                    name: "MODEL",
                    options: [
                        ["校正", "校正"],
                        ["重置", "重置"],
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "shape_statement"]
            })
        }
    };

    ScratchBlocks.Blocks.E7_getEyeData = {
        init: function () {
            this.jsonInit({
                message0: "智慧眼 %1 检测数值",
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "output_number"]
            })
        }
    };


    ScratchBlocks.Blocks.E7_getEyeRedData = {
        init: function () {
            this.jsonInit({
                message0: "智慧眼 %1 红外接收数据",
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "output_number"]
            })
        }
    };


    ScratchBlocks.Blocks.E7_setEyeRedData = {
        init: function () {
            this.jsonInit({
                message0: "智慧眼 %1 红外发送数据 %2",
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "input_value",
                    name: "VALUE"
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "shape_statement"]
            })
        }
    };



    ScratchBlocks.Blocks.E7_setEyeModel = {
        init: function () {
            this.jsonInit({
                message0: "智慧眼 %1 模式为 %2 颜色 %3",
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "MODEL",
                    options: [
                        ["彩虹流水灯", "彩虹流水灯"],
                        ["螺旋灯", "螺旋灯"],
                        ["单色流水灯", "单色流水灯"],
                        ["双闪灯", "双闪灯"],
                        ["分合灯", "分合灯"],
                        ["扫视灯", "扫视灯"],
                        ["红色呼吸灯", "红色呼吸灯"],
                        ["绿色呼吸灯", "绿色呼吸灯"],
                        ["蓝色呼吸灯", "蓝色呼吸灯"],
                    ]
                }, {
                    type: "input_value",
                    name: "COLOR1"
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "shape_statement"]
            })
        }
    };


    ScratchBlocks.Blocks.E7_setEyeColor = {
        init: function () {
            this.jsonInit({
                message0: "智慧眼 %1 颜色为 %2 %3 %4 %5 %6 %7 %8 %9",
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "input_value",
                    name: "COLOR1"
                }, {
                    type: "input_value",
                    name: "COLOR2"
                }, {
                    type: "input_value",
                    name: "COLOR3"
                }, {
                    type: "input_value",
                    name: "COLOR4"
                }, {
                    type: "input_value",
                    name: "COLOR5"
                }, {
                    type: "input_value",
                    name: "COLOR6"
                }, {
                    type: "input_value",
                    name: "COLOR7"
                }, {
                    type: "input_value",
                    name: "COLOR8"
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "shape_statement"]
            })
        }
    };

    ScratchBlocks.Blocks.STORM_OS_getColorRGB = {
        init: function () {
            this.jsonInit({
                message0: "颜色传感器 %1 RGB值",
                args0: [{
                    type: "field_dropdown",
                    name: "COLORPORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "output_number"]
            })
        }
    };

    ScratchBlocks.Blocks.STORM_OS_getColorRGB_values = {
        init: function () {
            this.jsonInit({
                message0: "颜色传感器 %1 %2 %3 %4 %5 %6 %7 %8 RGB值",
                args0: [{
                    type: "field_dropdown",
                    name: "PORT1",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ],
                    defaultItem: 1
                }, {
                    type: "field_dropdown",
                    name: "PORT2",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT3",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT4",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT5",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT6",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT7",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT8",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "output_number"]
            })
        }
    };

    ScratchBlocks.Blocks.STORM_OS_getLightSensor = {
        init: function () {
            this.jsonInit({
                message0: "光电传感器 %1 数值",
                args0: [{
                    type: "field_dropdown",
                    name: "PORT1",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "output_number"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_getLightSensor_values = {
        init: function () {
            this.jsonInit({
                message0: "光电传感器 %1 %2 %3 %4 %5 %6 %7 %8 数值",
                args0: [{
                    type: "field_dropdown",
                    name: "PORT1",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ],
                    defaultItem: 1
                }, {
                    type: "field_dropdown",
                    name: "PORT2",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT3",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT4",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT5",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT6",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT7",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT8",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "output_number"]
            })
        }
    };


    ScratchBlocks.Blocks.STORM_OS_set_photo_electric_threshold = {
        init: function () {
            this.jsonInit({
                message0: "设置光电传感器 %1 阈值 %2",
                args0: [{
                    type: "field_dropdown",
                    name: "PORT1",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "input_value",
                    name: "VALUE"
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "shape_statement"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_light_open = {
        init: function () {
            this.jsonInit({
                message0: "光电传感器 %1 打开补光灯",
                args0: [{
                    type: "field_dropdown",
                    name: "PORT1",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "shape_statement"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_light_close = {
        init: function () {
            this.jsonInit({
                message0: "光电传感器 %1 关闭补光灯",
                args0: [{
                    type: "field_dropdown",
                    name: "PORT1",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "shape_statement"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_touch_value = {
        init: function () {
            this.jsonInit({
                message0: "触碰传感器 %1 数值",
                args0: [{
                    type: "field_dropdown",
                    name: "PORT1",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "output_number"]
            })
        }
    };

    ScratchBlocks.Blocks.STORM_OS_touch_values = {
        init: function () {
            this.jsonInit({
                message0: "触碰传感器 %1 %2 %3 %4 %5 %6 %7 %8 数值",
                args0: [{
                    type: "field_dropdown",
                    name: "PORT1",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ],
                    defaultItem: 1
                }, {
                    type: "field_dropdown",
                    name: "PORT2",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT3",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT4",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT5",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT6",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT7",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT8",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "output_number"]
            })
        }
    };

    ScratchBlocks.Blocks.STORM_OS_getUltrasonic = {
        init: function () {
            this.jsonInit({
                message0: "超声波传感器 %1 数值",
                args0: [{
                    type: "field_dropdown",
                    name: "PORT1",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "output_number"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_getUltrasonic_values = {
        init: function () {
            this.jsonInit({
                message0: "超声波传感器 %1 %2 %3 %4 %5 %6 %7 %8 数值",
                args0: [{
                    type: "field_dropdown",
                    name: "PORT1",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ],
                    defaultItem: 1
                }, {
                    type: "field_dropdown",
                    name: "PORT2",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT3",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT4",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT5",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT6",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT7",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT8",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "output_number"]
            })
        }
    };

    ScratchBlocks.Blocks.STORM_OS_humidity_value = {
        init: function () {
            this.jsonInit({
                message0: "湿度传感器 %1 数值",
                args0: [{
                    type: "field_dropdown",
                    name: "PORT1",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "output_number"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_humidity_values = {
        init: function () {
            this.jsonInit({
                message0: "湿度传感器 %1 %2 %3 %4 %5 %6 %7 %8 数值",
                args0: [{
                    type: "field_dropdown",
                    name: "PORT1",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ],
                    defaultItem: 1
                }, {
                    type: "field_dropdown",
                    name: "PORT2",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT3",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT4",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT5",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT6",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT7",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT8",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "output_number"]
            })
        }
    };

    ScratchBlocks.Blocks.STORM_OS_temperature_value = {
        init: function () {
            this.jsonInit({
                message0: "温度传感器 %1 数值",
                args0: [{
                    type: "field_dropdown",
                    name: "PORT1",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "output_number"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_temperature_values = {
        init: function () {
            this.jsonInit({
                message0: "温度传感器 %1 %2 %3 %4 %5 %6 %7 %8 数值",
                args0: [{
                    type: "field_dropdown",
                    name: "PORT1",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ],
                    defaultItem: 1
                }, {
                    type: "field_dropdown",
                    name: "PORT2",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT3",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT4",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT5",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT6",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT7",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT8",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "output_number"]
            })
        }
    };

    ScratchBlocks.Blocks.STORM_OS_compass_value = {
        init: function () {
            this.jsonInit({
                message0: "指南针传感器 %1 数值",
                args0: [{
                    type: "field_dropdown",
                    name: "PORT1",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "output_number"]
            })
        }
    };

    ScratchBlocks.Blocks.STORM_OS_compass_values = {
        init: function () {
            this.jsonInit({
                message0: "指南针传感器 %1 %2 %3 %4 %5 %6 %7 %8 数值",
                args0: [{
                    type: "field_dropdown",
                    name: "PORT1",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ],
                    defaultItem: 1
                }, {
                    type: "field_dropdown",
                    name: "PORT2",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT3",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT4",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT5",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT6",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT7",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT8",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "output_number"]
            })
        }
    };


    ScratchBlocks.Blocks.STORM_OS_gyroscope_init = {
        init: function () {
            this.jsonInit({
                message0: "陀螺仪传感器 %1 较准",
                args0: [{
                    type: "field_dropdown",
                    name: "PORT1",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "shape_statement"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_gyroscope_value = {
        init: function () {
            this.jsonInit({
                message0: "陀螺仪传感器 %1 数值",
                args0: [{
                    type: "field_dropdown",
                    name: "PORT1",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "output_number"]
            })
        }
    };

    ScratchBlocks.Blocks.STORM_OS_gyroscope_values = {
        init: function () {
            this.jsonInit({
                message0: "陀螺仪传感器 %1 %2 %3 %4 %5 %6 %7 %8 数值",
                args0: [{
                    type: "field_dropdown",
                    name: "PORT1",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ],
                    defaultItem: 1
                }, {
                    type: "field_dropdown",
                    name: "PORT2",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT3",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT4",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT5",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT6",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT7",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT8",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "output_number"]
            })
        }
    };


    ScratchBlocks.Blocks.STORM_OS_set_color_light = {
        init: function () {
            this.jsonInit({
                message0: "彩灯模块 %1 设置为 %2",
                args0: [{
                    type: "field_dropdown",
                    name: "PORT1",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "COLOR1",
                    defaultItem: 7,
                    options: [
                        [ScratchBlocks.Msg.JMD_COLOR2, "1"], //red
                        [ScratchBlocks.Msg.JMD_COLOR3, "2"], //green
                        [ScratchBlocks.Msg.JMD_COLOR4, "3"], //blue
                        [ScratchBlocks.Msg.JMD_COLOR5, "4"], //yellow
                        [ScratchBlocks.Msg.JMD_COLOR6, "5"], //purple
                        [ScratchBlocks.Msg.JMD_COLOR7, "6"], //cyan
                        [ScratchBlocks.Msg.JMD_COLOR8, "7"], //white
                        [ScratchBlocks.Msg.JMD_COLOR9, "0"] //black
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "shape_statement"]
            })
        }
    };


    ScratchBlocks.Blocks.STORM_OS_set_color_lights = {
        init: function () {
            this.jsonInit({
                message0: "彩灯模块 %1 %2 %3 %4 %5 %6 %7 %8 设置为 %9 %10 %11 %12 %13 %14 %15 %16",
                args0: [{
                    type: "field_dropdown",
                    name: "PORT1",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ],
                    defaultItem: 1
                }, {
                    type: "field_dropdown",
                    name: "PORT2",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT3",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT4",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT5",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT6",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT7",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT8",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "COLOR1",
                    defaultItem: 7,
                    options: [
                        [ScratchBlocks.Msg.JMD_COLOR2, "1"], //red
                        [ScratchBlocks.Msg.JMD_COLOR3, "2"], //green
                        [ScratchBlocks.Msg.JMD_COLOR4, "3"], //blue
                        [ScratchBlocks.Msg.JMD_COLOR5, "4"], //yellow
                        [ScratchBlocks.Msg.JMD_COLOR6, "5"], //purple
                        [ScratchBlocks.Msg.JMD_COLOR7, "6"], //cyan
                        [ScratchBlocks.Msg.JMD_COLOR8, "7"], //white
                        [ScratchBlocks.Msg.JMD_COLOR9, "0"] //black
                    ]
                }, {
                    type: "field_dropdown",
                    name: "COLOR2",
                    defaultItem: 7,
                    options: [
                        [ScratchBlocks.Msg.JMD_COLOR2, "1"], //red
                        [ScratchBlocks.Msg.JMD_COLOR3, "2"], //green
                        [ScratchBlocks.Msg.JMD_COLOR4, "3"], //blue
                        [ScratchBlocks.Msg.JMD_COLOR5, "4"], //yellow
                        [ScratchBlocks.Msg.JMD_COLOR6, "5"], //purple
                        [ScratchBlocks.Msg.JMD_COLOR7, "6"], //cyan
                        [ScratchBlocks.Msg.JMD_COLOR8, "7"], //white
                        [ScratchBlocks.Msg.JMD_COLOR9, "0"] //black
                    ]
                }, {
                    type: "field_dropdown",
                    name: "COLOR3",
                    defaultItem: 7,
                    options: [
                        [ScratchBlocks.Msg.JMD_COLOR2, "1"], //red
                        [ScratchBlocks.Msg.JMD_COLOR3, "2"], //green
                        [ScratchBlocks.Msg.JMD_COLOR4, "3"], //blue
                        [ScratchBlocks.Msg.JMD_COLOR5, "4"], //yellow
                        [ScratchBlocks.Msg.JMD_COLOR6, "5"], //purple
                        [ScratchBlocks.Msg.JMD_COLOR7, "6"], //cyan
                        [ScratchBlocks.Msg.JMD_COLOR8, "7"], //white
                        [ScratchBlocks.Msg.JMD_COLOR9, "0"] //black
                    ]
                }, {
                    type: "field_dropdown",
                    name: "COLOR4",
                    defaultItem: 7,
                    options: [
                        [ScratchBlocks.Msg.JMD_COLOR2, "1"], //red
                        [ScratchBlocks.Msg.JMD_COLOR3, "2"], //green
                        [ScratchBlocks.Msg.JMD_COLOR4, "3"], //blue
                        [ScratchBlocks.Msg.JMD_COLOR5, "4"], //yellow
                        [ScratchBlocks.Msg.JMD_COLOR6, "5"], //purple
                        [ScratchBlocks.Msg.JMD_COLOR7, "6"], //cyan
                        [ScratchBlocks.Msg.JMD_COLOR8, "7"], //white
                        [ScratchBlocks.Msg.JMD_COLOR9, "0"] //black
                    ]
                }, {
                    type: "field_dropdown",
                    name: "COLOR5",
                    defaultItem: 7,
                    options: [
                        [ScratchBlocks.Msg.JMD_COLOR2, "1"], //red
                        [ScratchBlocks.Msg.JMD_COLOR3, "2"], //green
                        [ScratchBlocks.Msg.JMD_COLOR4, "3"], //blue
                        [ScratchBlocks.Msg.JMD_COLOR5, "4"], //yellow
                        [ScratchBlocks.Msg.JMD_COLOR6, "5"], //purple
                        [ScratchBlocks.Msg.JMD_COLOR7, "6"], //cyan
                        [ScratchBlocks.Msg.JMD_COLOR8, "7"], //white
                        [ScratchBlocks.Msg.JMD_COLOR9, "0"] //black
                    ]
                }, {
                    type: "field_dropdown",
                    name: "COLOR6",
                    defaultItem: 7,
                    options: [
                        [ScratchBlocks.Msg.JMD_COLOR2, "1"], //red
                        [ScratchBlocks.Msg.JMD_COLOR3, "2"], //green
                        [ScratchBlocks.Msg.JMD_COLOR4, "3"], //blue
                        [ScratchBlocks.Msg.JMD_COLOR5, "4"], //yellow
                        [ScratchBlocks.Msg.JMD_COLOR6, "5"], //purple
                        [ScratchBlocks.Msg.JMD_COLOR7, "6"], //cyan
                        [ScratchBlocks.Msg.JMD_COLOR8, "7"], //white
                        [ScratchBlocks.Msg.JMD_COLOR9, "0"] //black
                    ]
                }, {
                    type: "field_dropdown",
                    name: "COLOR7",
                    defaultItem: 7,
                    options: [
                        [ScratchBlocks.Msg.JMD_COLOR2, "1"], //red
                        [ScratchBlocks.Msg.JMD_COLOR3, "2"], //green
                        [ScratchBlocks.Msg.JMD_COLOR4, "3"], //blue
                        [ScratchBlocks.Msg.JMD_COLOR5, "4"], //yellow
                        [ScratchBlocks.Msg.JMD_COLOR6, "5"], //purple
                        [ScratchBlocks.Msg.JMD_COLOR7, "6"], //cyan
                        [ScratchBlocks.Msg.JMD_COLOR8, "7"], //white
                        [ScratchBlocks.Msg.JMD_COLOR9, "0"] //black
                    ]
                }, {
                    type: "field_dropdown",
                    name: "COLOR8",
                    defaultItem: 7,
                    options: [
                        [ScratchBlocks.Msg.JMD_COLOR2, "1"], //red
                        [ScratchBlocks.Msg.JMD_COLOR3, "2"], //green
                        [ScratchBlocks.Msg.JMD_COLOR4, "3"], //blue
                        [ScratchBlocks.Msg.JMD_COLOR5, "4"], //yellow
                        [ScratchBlocks.Msg.JMD_COLOR6, "5"], //purple
                        [ScratchBlocks.Msg.JMD_COLOR7, "6"], //cyan
                        [ScratchBlocks.Msg.JMD_COLOR8, "7"], //white
                        [ScratchBlocks.Msg.JMD_COLOR9, "0"] //black
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "shape_statement"]
            })
        }
    };


    ScratchBlocks.Blocks.STORM_OS_set_motor_speed = {
        init: function () {
            this.jsonInit({
                message0: "电机 %1 以 %2 速度转动",
                args0: [{
                    type: "field_dropdown",
                    name: "MOTORPORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT4, "4"]
                    ]
                }, {
                    type: "input_value",
                    name: "SPEED"
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_motor", "shape_statement"]
            })
        }
    };

    ScratchBlocks.Blocks.STORM_OS_set_motors_speed = {
        init: function () {
            this.jsonInit({
                message0: "电机 %1 %2 %3 %4 以 %5 %6 %7 %8 速度转动",
                args0: [{
                    type: "field_dropdown",
                    name: "MOTORPORT1",
                    defaultItem: 1,
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT4, "4"]
                    ]
                }, {
                    type: "field_dropdown",
                    name: "MOTORPORT2",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT4, "4"]
                    ]
                }, {
                    type: "field_dropdown",
                    name: "MOTORPORT3",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT4, "4"]
                    ]
                }, {
                    type: "field_dropdown",
                    name: "MOTORPORT4",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT4, "4"]
                    ]
                }, {
                    type: "input_value",
                    name: "SPEED1"
                }, {
                    type: "input_value",
                    name: "SPEED2"
                }, {
                    type: "input_value",
                    name: "SPEED3"
                }, {
                    type: "input_value",
                    name: "SPEED4"
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_motor", "shape_statement"]
            })
        }
    };

    ScratchBlocks.Blocks.STORM_OS_get_motor_code = {
        init: function () {
            this.jsonInit({
                message0: "获取电机端口 %1 的编码值",
                args0: [{
                    type: "field_dropdown",
                    name: "MOTORPORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT4, "4"]
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_motor", "output_number"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_get_motors_code = {
        init: function () {
            this.jsonInit({
                message0: "获取电机端口 %1 %2 %3 %4 的编码值",
                args0: [{
                    type: "field_dropdown",
                    name: "MOTORPORT1",
                    defaultItem: 1,
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT4, "4"]
                    ]
                }, {
                    type: "field_dropdown",
                    name: "MOTORPORT2",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT4, "4"]
                    ]
                }, {
                    type: "field_dropdown",
                    name: "MOTORPORT3",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT4, "4"]
                    ]
                }, {
                    type: "field_dropdown",
                    name: "MOTORPORT4",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT4, "4"]
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_motor", "output_number"]
            })
        }
    };


    ScratchBlocks.Blocks.STORM_OS_clear_motor_code = {
        init: function () {
            this.jsonInit({
                message0: "清除电机端口 %1 的编码值",
                args0: [{
                    type: "field_dropdown",
                    name: "MOTORPORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT4, "4"]
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_motor", "shape_statement"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_clear_motors_code = {
        init: function () {
            this.jsonInit({
                message0: "清除电机端口 %1 %2 %3 %4 的编码值",
                args0: [{
                    type: "field_dropdown",
                    name: "MOTORPORT1",
                    defaultItem: 1,
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT4, "4"]
                    ]
                }, {
                    type: "field_dropdown",
                    name: "MOTORPORT2",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT4, "4"]
                    ]
                }, {
                    type: "field_dropdown",
                    name: "MOTORPORT3",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT4, "4"]
                    ]
                }, {
                    type: "field_dropdown",
                    name: "MOTORPORT4",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT4, "4"]
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_motor", "shape_statement"]
            })
        }
    };

    ScratchBlocks.Blocks.STORM_OS_set_motor_servo_asyn = {
        init: function () {
            this.jsonInit({
                message0: "(异步) 设置伺服电机 %1 以速度 %2 转动 %3",
                args0: [{
                    type: "field_dropdown",
                    name: "MOTORPORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT4, "4"]
                    ]
                }, {
                    type: "input_value",
                    name: "SPEED"
                }, {
                    type: "input_value",
                    name: "ANGLE"
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_motor", "shape_statement"]
            })
        }
    };

    ScratchBlocks.Blocks.STORM_OS_set_motors_servo_asyn = {
        init: function () {
            this.jsonInit({
                message0: "(异步) 设置伺服电机 %1 %2 %3 %4 以速度 %5 %6 %7 %8 转动 %9 %10 %11 %12",
                args0: [{
                    type: "field_dropdown",
                    name: "MOTORPORT1",
                    defaultItem: 1,
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT4, "4"]
                    ]
                }, {
                    type: "field_dropdown",
                    name: "MOTORPORT2",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT4, "4"]
                    ]
                }, {
                    type: "field_dropdown",
                    name: "MOTORPORT3",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT4, "4"]
                    ]
                }, {
                    type: "field_dropdown",
                    name: "MOTORPORT4",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT4, "4"]
                    ]
                }, {
                    type: "input_value",
                    name: "SPEED1"
                }, {
                    type: "input_value",
                    name: "SPEED2"
                }, {
                    type: "input_value",
                    name: "SPEED3"
                }, {
                    type: "input_value",
                    name: "SPEED4"
                }, {
                    type: "input_value",
                    name: "ANGLE1"
                }, {
                    type: "input_value",
                    name: "ANGLE2"
                }, {
                    type: "input_value",
                    name: "ANGLE3"
                }, {
                    type: "input_value",
                    name: "ANGLE4"
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_motor", "shape_statement"]
            })
        }
    };


    ScratchBlocks.Blocks.STORM_OS_motor_servo_unlock = {
        init: function () {
            this.jsonInit({
                message0: "电机伺服模式 %1 解锁",
                args0: [{
                    type: "field_dropdown",
                    name: "MOTORPORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT4, "4"]
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_motor", "shape_statement"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_motors_servo_unlock = {
        init: function () {
            this.jsonInit({
                message0: "电机伺服模式 %1 %2 %3 %4 解锁",
                args0: [{
                    type: "field_dropdown",
                    name: "MOTORPORT1",
                    defaultItem: 1,
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT4, "4"]
                    ]
                }, {
                    type: "field_dropdown",
                    name: "MOTORPORT2",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT4, "4"]
                    ]
                }, {
                    type: "field_dropdown",
                    name: "MOTORPORT3",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT4, "4"]
                    ]
                }, {
                    type: "field_dropdown",
                    name: "MOTORPORT4",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT4, "4"]
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_motor", "shape_statement"]
            })
        }
    };

    ScratchBlocks.Blocks.STORM_OS_set_steering = {
        init: function () {
            this.jsonInit({
                message0: "舵机 %1 转动角度 %2",
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "input_value",
                    name: "ANGLE"
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_motor", "shape_statement"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_set_steerings = {
        init: function () {
            this.jsonInit({
                message0: "舵机 %1 %2 %3 转动角度 %4 %5 %6",
                args0: [{
                    type: "field_dropdown",
                    name: "PORT1",
                    defaultItem: 1,
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT2",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT3",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "input_value",
                    name: "ANGLE1"
                }, {
                    type: "input_value",
                    name: "ANGLE2"
                }, {
                    type: "input_value",
                    name: "ANGLE3"
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_motor", "shape_statement"]
            })
        }
    };

    ScratchBlocks.Blocks.STORM_OS_set_steering_unlock = {
        init: function () {
            this.jsonInit({
                message0: "(异步不锁) 舵机 %1 转动角度 %2",
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "input_value",
                    name: "ANGLE"
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_motor", "shape_statement"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_set_steerings_unlock = {
        init: function () {
            this.jsonInit({
                message0: "(异步不锁) 舵机 %1 %2 %3 转动角度 %4 %5 %6",
                args0: [{
                    type: "field_dropdown",
                    name: "PORT1",
                    defaultItem: 1,
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT2",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT3",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "input_value",
                    name: "ANGLE1"
                }, {
                    type: "input_value",
                    name: "ANGLE2"
                }, {
                    type: "input_value",
                    name: "ANGLE3"
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_motor", "shape_statement"]
            })
        }
    };


    ScratchBlocks.Blocks.STORM_OS_steering_unlock = {
        init: function () {
            this.jsonInit({
                message0: "舵机 %1 解锁",
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_motor", "shape_statement"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_steerings_unlock = {
        init: function () {
            this.jsonInit({
                message0: "舵机 %1 %2 %3 解锁",
                args0: [{
                    type: "field_dropdown",
                    name: "PORT1",
                    defaultItem: 1,
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT2",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "PORT3",
                    options: [
                        ["-", "-"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }],
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_motor", "shape_statement"]
            })
        }
    };





    // storm_os 图像

    ScratchBlocks.Blocks.STORM_OS_take_photo = {
        init: function () {
            this.jsonInit({
                message0: "摄像头获取图像",
                colour: "#4aaf8d",
                extensions: ["output_number"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_imshow_sensestorm = {
        init: function () {
            this.jsonInit({
                message0: "将图像 %1 显示在商小鸣屏幕",
                args0: [{
                    type: "input_value",
                    name: "IMG"
                }],
                colour: "#4aaf8d",
                extensions: ["shape_statement"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_imread_sensestorm = {
        init: function () {
            this.jsonInit({
                message0: "加载图像 %1",
                args0: [{
                    type: "input_value",
                    name: "PATH"
                }],
                colour: "#4aaf8d",
                extensions: ["output_number"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_imwrite_sensestorm = {
        init: function () {
            this.jsonInit({
                message0: "将图像 %1 存储为 %2",
                args0: [{
                    type: "input_value",
                    name: "IMG"
                }, {
                    type: "input_value",
                    name: "PATH"
                }],
                colour: "#4aaf8d",
                extensions: ["shape_statement"]
            })
        }
    };


    // storm_os 输出

    ScratchBlocks.Blocks.STORM_OS_PRINT = {
        init: function () {
            this.jsonInit({
                message0: "打印 %1",
                args0: [{
                    type: "input_value",
                    name: "TEXT"
                }],
                colour: "#2c9958",
                extensions: ["shape_statement"]
            })
        }
    };



    // storm_os 控制器

    ScratchBlocks.Blocks.STORM_OS_jmd_start = {
        init: function () {
            this.jsonInit({
                message0: "控制器运行",
                extensions: ["colours_jmd", "shape_hat"]
            })
        }
    };


    ScratchBlocks.Blocks.STORM_OS_record_audio = {
        init: function () {
            this.jsonInit({
                message0: "录制声音 %1 秒并以名称 %2 存储",
                args0: [{
                    type: "input_value",
                    name: "SECOND",
                }, {
                    type: "input_value",
                    name: "FILENAME",
                }],
                extensions: ["colours_jmd", "shape_statement"]
            })
        }
    };

    ScratchBlocks.Blocks.STORM_OS_play_preset_audio = {
        init: function () {
            this.jsonInit({
                message0: "播放内置声音 %1",
                args0: [{
                    type: "field_dropdown",
                    name: "FILE",
                    options: [
                        ["狗叫", "狗叫.wav"],
                        ["猫叫", "猫.wav"],
                        ["喇叭", "喇叭声.wav"],
                        ["锣声", "锣声.wav"],
                        ["成功", "成功声音.wav"],
                        ["失败", "失败音效2.wav"],
                        ["警报", "消防车声.wav"],
                        ["快门", "拍照快门声.wav"],
                    ]
                }],
                extensions: ["colours_jmd", "shape_statement"]
            })
        }
    };

    ScratchBlocks.Blocks.STORM_OS_play_audio = {
        init: function () {
            this.jsonInit({
                message0: "播放文件 %1",
                args0: [{
                    type: "input_value",
                    name: "FILENAME"
                }],
                extensions: ["colours_jmd", "shape_statement"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_tone = {
        init: function () {
            this.jsonInit({
                message0: "播放频率为 %1 声音 %2 秒",
                args0: [{
                    type: "input_value",
                    name: "VOLUME"
                }, {
                    type: "input_value",
                    name: "SECOND"
                }],
                extensions: ["colours_jmd", "shape_statement"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_beep = {
        init: function () {
            this.jsonInit({
                message0: "播放蜂鸣器",
                extensions: ["colours_jmd", "shape_statement"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_fan_speed = {
        init: function () {
            this.jsonInit({
                message0: "风扇速度",
                extensions: ["colours_jmd", "output_number"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_set_fan_speed = {
        init: function () {
            this.jsonInit({
                message0: "设置风扇转动速度 %1",
                args0: [{
                    type: "input_value",
                    name: "SPEED"
                }],
                extensions: ["colours_jmd", "shape_statement"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_fw_version = {
        init: function () {
            this.jsonInit({
                message0: "固件版本号",
                extensions: ["colours_jmd", "output_number"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_battery = {
        init: function () {
            this.jsonInit({
                message0: "电池电量",
                extensions: ["colours_jmd", "output_number"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_charging = {
        init: function () {
            this.jsonInit({
                message0: "是否充电",
                extensions: ["colours_jmd", "output_boolean"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_reset = {
        init: function () {
            this.jsonInit({
                message0: "端口复位",
                extensions: ["colours_jmd", "output_number"]
            })
        }
    };



    // AI-人脸识别

    ScratchBlocks.Blocks.STORM_OS_get_face_attributes = {
        init: function () {
            this.jsonInit({
                message0: "AI获取图像 %1 中的人脸属性",
                args0: [{
                    type: "input_value",
                    name: "INPUT",
                }],
                colour: "#1a408f",
                extensions: ["output_number"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_is_face_smiled = {
        init: function () {
            this.jsonInit({
                message0: "AI图像 %1 中的人脸是否微笑？",
                args0: [{
                    type: "input_value",
                    name: "INPUT",
                }],
                colour: "#1a408f",
                extensions: ["output_boolean"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_get_face_attribute_two = {
        init: function () {
            this.jsonInit({
                message0: "AI获取图像 %1 中的人脸的 %2",
                args0: [{
                    type: "input_value",
                    name: "INPUT",
                }, {
                    type: "field_dropdown",
                    name: "STATUS",
                    options: [
                        ['性别', 'gender'],
                        ['年龄', 'age'],
                        ['颜值', 'attractive'],
                        ['表情', 'emotion'],
                        ['眼睛', 'eye']
                    ]
                }],
                colour: "#1a408f",
                extensions: ["output_number"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_is_face_existed = {
        init: function () {
            this.jsonInit({
                message0: "AI图像 %1 中是否存在人脸？",
                args0: [{
                    type: "input_value",
                    name: "INPUT",
                }],
                colour: "#1a408f",
                extensions: ["output_boolean"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_detect_face = {
        init: function () {
            this.jsonInit({
                message0: "AI检测图像 %1 中的人脸位置",
                args0: [{
                    type: "input_value",
                    name: "INPUT",
                }],
                colour: "#1a408f",
                extensions: ["output_number"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_extract_face_feature = {
        init: function () {
            this.jsonInit({
                message0: "AI提取图像 %1 中的人脸特征",
                args0: [{
                    type: "input_value",
                    name: "INPUT",
                }],
                colour: "#1a408f",
                extensions: ["output_number"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_calculate_feature_similarity = {
        init: function () {
            this.jsonInit({
                message0: "AI计算 %1 与 %2 的特征相似度",
                args0: [{
                    type: "input_value",
                    name: "INPUT",
                }, {
                    type: "input_value",
                    name: "INPUT2",
                }],
                colour: "#1a408f",
                extensions: ["output_number"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_get_face_pose = {
        init: function () {
            this.jsonInit({
                message0: "AI获取图像 %1 中的人脸角度",
                args0: [{
                    type: "input_value",
                    name: "INPUT",
                }],
                colour: "#1a408f",
                extensions: ["output_number"]
            })
        }
    };


    // storm_os   AI-人体识别
    ScratchBlocks.Blocks.STORM_OS_is_hand_existed = {
        init: function () {
            this.jsonInit({
                message0: "AI图像 %1 中是否存在手？",
                args0: [{
                    type: "input_value",
                    name: "INPUT",
                }],
                colour: "#2b772e",
                extensions: ["output_boolean"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_detect_hand = {
        init: function () {
            this.jsonInit({
                message0: "AI检测图像 %1 中的手的位置",
                args0: [{
                    type: "input_value",
                    name: "INPUT",
                }],
                colour: "#2b772e",
                extensions: ["output_number"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_is_gesture_existed = {
        init: function () {
            this.jsonInit({
                message0: "AI图像 %1 中的手势是否为 %2",
                args0: [{
                    type: "input_value",
                    name: "INPUT",
                }, {
                    type: "field_dropdown",
                    name: "STATUS",
                    options: [
                        ["OK", "OK"],
                        ["胜利（剪刀）", "V"],
                        ["停止（布）", "STOP"],
                        ["拳头（石头）", "FIST"],
                        ["点赞", "THUMB_UP"],
                        ["手枪", "TICK"],
                        ["666", "SIX"]
                    ]
                }],
                colour: "#2b772e",
                extensions: ["output_boolean"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_detect_gesture = {
        init: function () {
            this.jsonInit({
                message0: "AI识别图像 %1 中的手势类别",
                args0: [{
                    type: "input_value",
                    name: "INPUT",
                }],
                colour: "#2b772e",
                extensions: ["output_number"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_detect_hand_points = {
        init: function () {
            this.jsonInit({
                message0: "AI检测图像 %1 中指尖关键点",
                args0: [{
                    type: "input_value",
                    name: "INPUT",
                }],
                colour: "#2b772e",
                extensions: ["output_number"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_is_body_existed = {
        init: function () {
            this.jsonInit({
                message0: "AI图像 %1 中是否存在人体？",
                args0: [{
                    type: "input_value",
                    name: "INPUT",
                }],
                colour: "#2b772e",
                extensions: ["output_boolean"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_detect_body = {
        init: function () {
            this.jsonInit({
                message0: "AI检测图像 %1 中的人体位置",
                args0: [{
                    type: "input_value",
                    name: "INPUT",
                }],
                colour: "#2b772e",
                extensions: ["output_number"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_detect_body_key_points = {
        init: function () {
            this.jsonInit({
                message0: "AI检测图像 %1 中的人体关键点",
                args0: [{
                    type: "input_value",
                    name: "INPUT",
                }],
                colour: "#2b772e",
                extensions: ["output_number"]
            })
        }
    };

    // AI-图像检测
    ScratchBlocks.Blocks.STORM_OS_is_ball_existed = {
        init: function () {
            this.jsonInit({
                message0: "AI图像 %1 中是否存在小球？",
                args0: [{
                    type: "input_value",
                    name: "INPUT",
                }],
                colour: "#827315",
                extensions: ["output_boolean"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_detect_ball = {
        init: function () {
            this.jsonInit({
                message0: "AI检测图像 %1 中的小球位置",
                args0: [{
                    type: "input_value",
                    name: "INPUT",
                }],
                colour: "#827315",
                extensions: ["output_number"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_classify_image = {
        init: function () {
            this.jsonInit({
                message0: "AI检测图像 %1 中的物体类别",
                args0: [{
                    type: "input_value",
                    name: "INPUT",
                }],
                colour: "#827315",
                extensions: ["output_number"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_detect_lane_line = {
        init: function () {
            this.jsonInit({
                message0: "AI检测图像 %1 中车道线位置",
                args0: [{
                    type: "input_value",
                    name: "INPUT",
                }],
                colour: "#827315",
                extensions: ["output_number"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_get_pid_speed = {
        init: function () {
            this.jsonInit({
                message0: "根据车道线位置 %1 %2 获取 %3 速度",
                args0: [{
                    type: "input_value",
                    name: "INPUT",
                }, {
                    type: "input_value",
                    name: "INPUT2",
                }, {
                    type: "field_dropdown",
                    name: "SPEED",
                    options: [
                        ["左轮", "left"],
                        ["右轮", "right"],
                        ["所有", "both"],
                    ]
                }],
                colour: "#827315",
                extensions: ["output_number"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_detect_plant = {
        init: function () {
            this.jsonInit({
                message0: "AI检测图像 %1 中的植物",
                args0: [{
                    type: "input_value",
                    name: "INPUT",
                }],
                colour: "#827315",
                extensions: ["output_number"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_detect_mineral = {
        init: function () {
            this.jsonInit({
                message0: "AI检测图像 %1 中的矿石",
                args0: [{
                    type: "input_value",
                    name: "INPUT",
                }],
                colour: "#827315",
                extensions: ["output_number"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_get_result_label = {
        init: function () {
            this.jsonInit({
                message0: "AI获取检测结果 %1 中的物体类别",
                args0: [{
                    type: "input_value",
                    name: "INPUT",
                }],
                colour: "#827315",
                extensions: ["output_number"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_get_result_coordinate = {
        init: function () {
            this.jsonInit({
                message0: "AI根据检测结果 %1 获取检测物的 %2",
                args0: [{
                    type: "input_value",
                    name: "INPUT",
                }, {
                    type: "field_dropdown",
                    name: "POSITION",
                    options: [
                        ["中心点x坐标", "x"],
                        ["中心点y坐标", "y"],
                        ["面积", "s"],
                    ]
                }],
                colour: "#827315",
                extensions: ["output_number"]
            })
        }
    };


    // AI-机器学习

    ScratchBlocks.Blocks.STORM_OS_extract_imageNet = {
        init: function () {
            this.jsonInit({
                message0: "AI提取图像 %1 的特征",
                args0: [{
                    type: "input_value",
                    name: "INPUT",
                }],
                colour: "#991117",
                extensions: ["output_number"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_train_classifier = {
        init: function () {
            this.jsonInit({
                message0: "AI根据 %1 中的数据集训练图像分类器",
                args0: [{
                    type: "input_value",
                    name: "NAME",
                }],
                colour: "#991117",
                extensions: ["output_number"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_save_model = {
        init: function () {
            this.jsonInit({
                message0: "AI保存图像分类器 %1 并命名为 %2",
                args0: [{
                    type: "input_value",
                    name: "INPUT",
                }, {
                    type: "input_value",
                    name: "RENAME",
                }],
                colour: "#991117",
                extensions: ["shape_statement"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_load_model = {
        init: function () {
            this.jsonInit({
                message0: "AI加载名为 %1 的分类器",
                args0: [{
                    type: "input_value",
                    name: "NAME",
                }],
                colour: "#991117",
                extensions: ["output_number"]
            })
        }
    };
    ScratchBlocks.Blocks.STORM_OS_predict = {
        init: function () {
            this.jsonInit({
                message0: "AI根据模型 %1 预测图像 %2 类别",
                args0: [{
                    type: "input_value",
                    name: "INPUT",
                }, {
                    type: "input_value",
                    name: "INPUT2",
                }],
                colour: "#991117",
                extensions: ["output_number"]
            })
        }
    };


    // AI-智能语音


    ScratchBlocks.Blocks.STORM_OS_speak = {
        init: function () {
            this.jsonInit({
                message0: "AI将 %1 转化为语音",
                args0: [{
                    type: "input_value",
                    name: "TEXT",
                }],
                colour: "#620976",
                extensions: ["shape_statement"]
            })
        }
    };


    ScratchBlocks.Blocks.STORM_OS_classify_audio = {
        init: function () {
            this.jsonInit({
                message0: "AI将 %1 转化为文字",
                args0: [{
                    type: "input_value",
                    name: "FILENAME",
                }],
                colour: "#620976",
                extensions: ["output_number"]
            })
        }
    };


    ScratchBlocks.Blocks.E6_motor_setMagneticServoDegreeTime = {
        init: function () {
            this.jsonInit({
                // message0: "%1 %2",
                // args0: [{
                //     type: "field_image",
                //     src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/E6/duoji_icon.svg",
                //     width: 30,
                //     height: 26

                // }, {
                //     type: "field_vertical_separator"
                // }],
                message0: ScratchBlocks.Msg.MOTOR_SETMAGNETICSERVODEGREETIME,
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "input_value",
                    name: "ANGLE",
                }, {
                    type: "input_value",
                    name: "TIME",
                }],
                extensions: ["colours_SteeringEngine", "shape_statement"]
            })
        }
    };

    ScratchBlocks.Blocks.E6_motor_setMagneticServoDegreeSpeed = {
        init: function () {
            this.jsonInit({
                // message0: "%1 %2",
                // args0: [{
                //     type: "field_image",
                //     src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/E6/duoji_icon.svg",
                //     width: 30,
                //     height: 26

                // }, {
                //     type: "field_vertical_separator"
                // }],
                message0: ScratchBlocks.Msg.MOTOR_SETMAGNETICSERVODEGREESPEED,
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "input_value",
                    name: "ANGLE",
                }, {
                    type: "input_value",
                    name: "SPEED",
                }],
                extensions: ["colours_SteeringEngine", "shape_statement"]
            })
        }
    };
    ScratchBlocks.Blocks.E6_motor_setMagneticServoCodeMotor = {
        init: function () {
            this.jsonInit({
                // message0: "%1 %2",
                // args0: [{
                //     type: "field_image",
                //     src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/E6/duoji_icon.svg",
                //     width: 30,
                //     height: 26

                // }, {
                //     type: "field_vertical_separator"
                // }],
                message0: ScratchBlocks.Msg.MOTOR_SETMAGNETICSERVOCODEMOTOR,
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "input_value",
                    name: "ANGLE",
                }, {
                    type: "input_value",
                    name: "SPEED",
                }],
                extensions: ["colours_SteeringEngine", "shape_statement"]
            })
        }
    };


    ScratchBlocks.Blocks.E3_motor_setMagneticServoDegreeTime = {
        init: function () {
            this.jsonInit({
                // message0: "%1 %2",
                // args0: [{
                //     type: "field_image",
                //     src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/E6/motor_icon.svg",
                //     width: 30,
                //     height: 26

                // }, {
                //     type: "field_vertical_separator"
                // }],
                message0: ScratchBlocks.Msg.MOTOR_SETMAGNETICSERVODEGREETIME,
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "input_value",
                    name: "ANGLE",
                }, {
                    type: "input_value",
                    name: "TIME",
                }],
                extensions: ["colours_motor", "shape_statement"]
            })
        }
    };

    ScratchBlocks.Blocks.E3_motor_setMagneticServoDegreeSpeed = {
        init: function () {
            this.jsonInit({
                // message0: "%1 %2",
                // args0: [{
                //     type: "field_image",
                //     src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/E6/motor_icon.svg",
                //     width: 30,
                //     height: 26

                // }, {
                //     type: "field_vertical_separator"
                // }],
                message0: ScratchBlocks.Msg.MOTOR_SETMAGNETICSERVODEGREESPEED,
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "input_value",
                    name: "ANGLE",
                }, {
                    type: "input_value",
                    name: "SPEED",
                }],
                extensions: ["colours_motor", "shape_statement"]
            })
        }
    };
    ScratchBlocks.Blocks.E3_motor_setMagneticServoCodeMotor = {
        init: function () {
            this.jsonInit({
                // message0: "%1 %2",
                // args0: [{
                //     type: "field_image",
                //     src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/E6/motor_icon.svg",
                //     width: 30,
                //     height: 26

                // }, {
                //     type: "field_vertical_separator"
                // }],
                message0: ScratchBlocks.Msg.MOTOR_SETMAGNETICSERVOCODEMOTOR,
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "input_value",
                    name: "ANGLE",
                }, {
                    type: "input_value",
                    name: "SPEED",
                }],
                extensions: ["colours_motor", "shape_statement"]
            })
        }
    };


    ScratchBlocks.Blocks.M6_motor_setMagneticServoDegreeTime = {
        init: function () {
            this.jsonInit({
                // message0: "%1 %2",
                // args0: [{
                //     type: "field_image",
                //     src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/E6/duoji_icon.svg",
                //     width: 30,
                //     height: 26

                // }, {
                //     type: "field_vertical_separator"
                // }],
                message0: ScratchBlocks.Msg.MOTOR_SETMAGNETICSERVODEGREETIME,
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                    ]
                }, {
                    type: "input_value",
                    name: "ANGLE",
                }, {
                    type: "input_value",
                    name: "TIME",
                }],
                extensions: ["colours_SteeringEngine", "shape_statement"]
            })
        }
    };

    ScratchBlocks.Blocks.M6_motor_setMagneticServoDegreeSpeed = {
        init: function () {
            this.jsonInit({
                // message0: "%1 %2",
                // args0: [{
                //     type: "field_image",
                //     src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/E6/duoji_icon.svg",
                //     width: 30,
                //     height: 26

                // }, {
                //     type: "field_vertical_separator"
                // }],
                message0: ScratchBlocks.Msg.MOTOR_SETMAGNETICSERVODEGREESPEED,
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                    ]
                }, {
                    type: "input_value",
                    name: "ANGLE",
                }, {
                    type: "input_value",
                    name: "SPEED",
                }],
                extensions: ["colours_SteeringEngine", "shape_statement"]
            })
        }
    };
    ScratchBlocks.Blocks.M6_motor_setMagneticServoCodeMotor = {
        init: function () {
            this.jsonInit({
                // message0: "%1 %2",
                // args0: [{
                //     type: "field_image",
                //     src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/E6/duoji_icon.svg",
                //     width: 30,
                //     height: 26

                // }, {
                //     type: "field_vertical_separator"
                // }],
                message0: ScratchBlocks.Msg.MOTOR_SETMAGNETICSERVOCODEMOTOR,
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                    ]
                }, {
                    type: "input_value",
                    name: "ANGLE",
                }, {
                    type: "input_value",
                    name: "SPEED",
                }],
                extensions: ["colours_SteeringEngine", "shape_statement"]
            })
        }
    };

    ScratchBlocks.Blocks.E6_motor_setSeeringEngine = {
        init: function () {
            this.jsonInit({
                // message0: "%1 %2",
                // args0: [{
                //     type: "field_image",
                //     src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/E6/duoji_icon.svg",
                //     width: 30,
                //     height: 26

                // }, {
                //     type: "field_vertical_separator"
                // }],
                message0: ScratchBlocks.Msg.MOTOR_SETSEERINGENGINE,
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "3"],
                    ]
                }, {
                    type: "input_value",
                    name: "ANGLE",
                }],
                extensions: ["colours_SteeringEngine", "shape_statement"]
            })
        }
    };
    ScratchBlocks.Blocks.E3_motor_setSeeringEngine = {
        init: function () {
            this.jsonInit({
                // message0: "%1 %2",
                // args0: [{
                //     type: "field_image",
                //     src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/E6/motor_icon.svg",
                //     width: 30,
                //     height: 26

                // }, {
                //     type: "field_vertical_separator"
                // }],
                message0: ScratchBlocks.Msg.MOTOR_SETSEERINGENGINE,
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                    ]
                }, {
                    type: "input_value",
                    name: "ANGLE",
                }],
                extensions: ["colours_motor", "shape_statement"]
            })
        }
    };
    ScratchBlocks.Blocks.M6_motor_setSeeringEngine = {
        init: function () {
            this.jsonInit({
                // message0: "%1 %2",
                // args0: [{
                //     type: "field_image",
                //     src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/E6/duoji_icon.svg",
                //     width: 30,
                //     height: 26

                // }, {
                //     type: "field_vertical_separator"
                // }],
                message0: ScratchBlocks.Msg.MOTOR_SETSEERINGENGINE,
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "3"],
                    ]
                }, {
                    type: "input_value",
                    name: "ANGLE",
                }],
                extensions: ["colours_SteeringEngine", "shape_statement"]
            })
        }
    };
    ScratchBlocks.Blocks.E6_motor_setSeeringEngineTime = {
        init: function () {
            this.jsonInit({
                // message0: "%1 %2",
                // args0: [{
                //     type: "field_image",
                //     src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/E6/duoji_icon.svg",
                //     width: 30,
                //     height: 26

                // }, {
                //     type: "field_vertical_separator"
                // }],
                message0: ScratchBlocks.Msg.MOTOR_SETSEERINGENGINETIME,
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "3"],
                    ]
                }, {
                    type: "input_value",
                    name: "ANGLE",
                }, {
                    type: "input_value",
                    name: "TIME",
                }],
                extensions: ["colours_SteeringEngine", "shape_statement"]
            })
        }
    };
    ScratchBlocks.Blocks.E3_motor_setSeeringEngineTime = {
        init: function () {
            this.jsonInit({
                // message0: "%1 %2",
                // args0: [{
                //     type: "field_image",
                //     src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/E6/motor_icon.svg",
                //     width: 30,
                //     height: 26

                // }, {
                //     type: "field_vertical_separator"
                // }],
                message0: ScratchBlocks.Msg.MOTOR_SETSEERINGENGINETIME,
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"]
                    ]
                }, {
                    type: "input_value",
                    name: "ANGLE",
                }, {
                    type: "input_value",
                    name: "TIME",
                }],
                extensions: ["colours_motor", "shape_statement"]
            })
        }
    };
    ScratchBlocks.Blocks.M6_motor_setSeeringEngineTime = {
        init: function () {
            this.jsonInit({
                // message0: "%1 %2",
                // args0: [{
                //     type: "field_image",
                //     src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/E6/duoji_icon.svg",
                //     width: 30,
                //     height: 26

                // }, {
                //     type: "field_vertical_separator"
                // }],
                message0: ScratchBlocks.Msg.MOTOR_SETSEERINGENGINETIME,
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "3"]
                    ]
                }, {
                    type: "input_value",
                    name: "ANGLE",
                }, {
                    type: "input_value",
                    name: "TIME",
                }],
                extensions: ["colours_SteeringEngine", "shape_statement"]
            })
        }
    };

    ScratchBlocks.Blocks.jmd_setUartData = {
        init: function () {
            this.jsonInit({
                // message0: "%1 %2",
                // args0: [{
                //     type: "field_image",
                //     src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/E6/E6_rcu_icon.svg",
                //     width: 30,
                //     height: 26

                // }, {
                //     type: "field_vertical_separator"
                // }],
                message0: ScratchBlocks.Msg.JMD_SETUARTDATA,
                args0: [{
                    type: "input_value",
                    name: "DATA",
                }, {
                    type: "field_dropdown",
                    name: "BAUDRATE",
                    options: [
                        ["9600", "9600"],
                        ["14400", "14400"],
                        ["19200", "19200"],
                        ["38400", "38400"],
                        ["57600", "57600"],
                        ["76800", "76800"],
                        ["115200", "115200"],
                        ["128000", "128000"],
                        ["256000", "256000"],
                        ["512000", "512000"],
                        ["921600", "921600"]
                    ]
                }],
                extensions: ["colours_jmd", "shape_statement"]
            })
        }
    };
    ScratchBlocks.Blocks.jmd_getUartData = {
        init: function () {
            this.jsonInit({
                // message0: "%1 %2",
                // args0: [{
                //     type: "field_image",
                //     src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/E6/E6_rcu_icon.svg",
                //     width: 30,
                //     height: 26

                // }, {
                //     type: "field_vertical_separator"
                // }],
                message0: ScratchBlocks.Msg.JMD_GETUARTDATA,
                args0: [{
                    type: "field_dropdown",
                    name: "BAUDRATE",
                    options: [
                        ["9600", "9600"],
                        ["14400", "14400"],
                        ["19200", "19200"],
                        ["38400", "38400"],
                        ["57600", "57600"],
                        ["76800", "76800"],
                        ["115200", "115200"],
                        ["128000", "128000"],
                        ["256000", "256000"],
                        ["512000", "512000"],
                        ["921600", "921600"]
                    ]
                }],
                extensions: ["colours_jmd", "output_number"]
            })
        }
    };

    ScratchBlocks.Blocks.jmd_setMp3Sound = {
        init: function () {
            this.jsonInit({
                message0: ScratchBlocks.Msg.JMD_SETMP3SOUND,
                args0: [{
                    type: "input_value",
                    name: "VOLUME",
                }],
                extensions: ["colours_jmd", "shape_statement"]
            })
        }
    };

    ScratchBlocks.Blocks.show_setDisplayVarU32 = {
        init: function () {
            this.jsonInit({
                // message0: "%1 %2",
                // args0: [{
                //     type: "field_image",
                //     src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/E6/show_icon.svg",
                //     width: 30,
                //     height: 26

                // }, {
                //     type: "field_vertical_separator"
                // }],
                message0: ScratchBlocks.Msg.SHOW_SETDISPLAYVARU32,
                args0: [{
                    type: "input_value",
                    name: "LINE",
                }, {
                    type: "input_value",
                    name: "VALUE",
                }, {
                    type: "field_dropdown",
                    name: "FONTCOLOR",
                    defaultItem: 3,
                    options: [
                        [ScratchBlocks.Msg.JMD_COLOR2, "0xF800"], //red
                        [ScratchBlocks.Msg.JMD_COLOR3, "0x07E0"], //green
                        [ScratchBlocks.Msg.JMD_COLOR4, "0x001F"], //blue
                        [ScratchBlocks.Msg.JMD_COLOR5, "0xFFE0"], //yellow
                        [ScratchBlocks.Msg.JMD_COLOR6, "0xF81F"], //purple
                        [ScratchBlocks.Msg.JMD_COLOR7, "0x07FF"], //cyan
                        [ScratchBlocks.Msg.JMD_COLOR8, "0xFFFF"], //white
                        [ScratchBlocks.Msg.JMD_COLOR10, "0x0000"] //black
                    ]
                }, {
                    type: "field_dropdown",
                    name: "BGCOLOR",
                    defaultItem: 7,
                    options: [
                        [ScratchBlocks.Msg.JMD_COLOR2, "0xF800"], //red
                        [ScratchBlocks.Msg.JMD_COLOR3, "0x07E0"], //green
                        [ScratchBlocks.Msg.JMD_COLOR4, "0x001F"], //blue
                        [ScratchBlocks.Msg.JMD_COLOR5, "0xFFE0"], //yellow
                        [ScratchBlocks.Msg.JMD_COLOR6, "0xF81F"], //purple
                        [ScratchBlocks.Msg.JMD_COLOR7, "0x07FF"], //cyan
                        [ScratchBlocks.Msg.JMD_COLOR8, "0xFFFF"], //white
                        [ScratchBlocks.Msg.JMD_COLOR10, "0x0000"] //black
                    ]
                }],
                extensions: ["colours_show", "shape_statement"]
            })
        }
    };

    ScratchBlocks.Blocks.show_setDisplayFloat = {
        init: function () {
            this.jsonInit({
                // message0: "%1 %2",
                // args0: [{
                //     type: "field_image",
                //     src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/E6/show_icon.svg",
                //     width: 30,
                //     height: 26

                // }, {
                //     type: "field_vertical_separator"
                // }],
                message0: ScratchBlocks.Msg.SHOW_SETDISPLAYFLOAT,
                args0: [{
                    type: "input_value",
                    name: "LINE",
                }, {
                    type: "input_value",
                    name: "VALUE",
                }, {
                    type: "field_dropdown",
                    name: "FONTCOLOR",
                    defaultItem: 3,
                    options: [
                        [ScratchBlocks.Msg.JMD_COLOR2, "0xF800"], //red
                        [ScratchBlocks.Msg.JMD_COLOR3, "0x07E0"], //green
                        [ScratchBlocks.Msg.JMD_COLOR4, "0x001F"], //blue
                        [ScratchBlocks.Msg.JMD_COLOR5, "0xFFE0"], //yellow
                        [ScratchBlocks.Msg.JMD_COLOR6, "0xF81F"], //purple
                        [ScratchBlocks.Msg.JMD_COLOR7, "0x07FF"], //cyan
                        [ScratchBlocks.Msg.JMD_COLOR8, "0xFFFF"], //white
                        [ScratchBlocks.Msg.JMD_COLOR10, "0x0000"] //black
                    ]
                }, {
                    type: "field_dropdown",
                    name: "BGCOLOR",
                    defaultItem: 7,
                    options: [
                        [ScratchBlocks.Msg.JMD_COLOR2, "0xF800"], //red
                        [ScratchBlocks.Msg.JMD_COLOR3, "0x07E0"], //green
                        [ScratchBlocks.Msg.JMD_COLOR4, "0x001F"], //blue
                        [ScratchBlocks.Msg.JMD_COLOR5, "0xFFE0"], //yellow
                        [ScratchBlocks.Msg.JMD_COLOR6, "0xF81F"], //purple
                        [ScratchBlocks.Msg.JMD_COLOR7, "0x07FF"], //cyan
                        [ScratchBlocks.Msg.JMD_COLOR8, "0xFFFF"], //white
                        [ScratchBlocks.Msg.JMD_COLOR10, "0x0000"] //black
                    ]
                }],
                extensions: ["colours_show", "shape_statement"]
            })
        }
    };


    ScratchBlocks.Blocks.hrcu_iot_isIotInit = {
        init: function () {
            this.jsonInit({
                message0: "iot初始化？",
                colour: "#00d7b1",
                extensions: ["output_boolean"]
            })
        }
    };

    ScratchBlocks.Blocks.hrcu_iot_startWebService = {
        init: function () {
            this.jsonInit({
                message0: "模拟钓鱼网站服务器",
                colour: "#00d7b1",
                extensions: ["shape_statement"]
            })
        }
    };
    ScratchBlocks.Blocks.hrcu_iot_getWebUrl = {
        init: function () {
            this.jsonInit({
                message0: "获取钓鱼网站网址",
                colour: "#00d7b1",
                extensions: ["output_number"]
            })
        }
    };
    ScratchBlocks.Blocks.hrcu_iot_getWebData = {
        init: function () {
            this.jsonInit({
                message0: "获取已经登录的 %1",
                args0: [{
                    type: "field_dropdown",
                    name: "ACCOUNTTYPE",
                    options: [
                        ["账号", "账号"],
                        ["密码", "密码"]
                    ]
                }],
                colour: "#00d7b1",
                extensions: ["output_number"]
            })
        }
    };


    // M5控制器

    ScratchBlocks.Blocks.motor_M5_setMotor = {
        init: function () {
            this.jsonInit({
                message0: ScratchBlocks.Msg.MOTOR_SETMOTOR,
                args0: [{
                    type: "field_dropdown",
                    name: "MOTORPORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT2, "2"]
                    ]
                }, {
                    type: "input_value",
                    name: "VALUE",
                }],
                colour: ScratchBlocks.Colours.motor.secondary,
                colourSecondary: ScratchBlocks.Colours.motor.secondary,
                colourTertiary: ScratchBlocks.Colours.motor.tertiary,
                category: ScratchBlocks.Categories.motor,
                extensions: ["colours_motor", "shape_statement"]
            })
        }
    };


    ScratchBlocks.Blocks.motor_M5_SetServo = {
        init: function () {
            this.jsonInit({
                message0: ScratchBlocks.Msg.MOTOR_SETSERVO,
                args0: [{
                    type: "field_dropdown",
                    name: "MOTORPORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                    ]
                }, {
                    type: "input_value",
                    name: "ANGLE"
                }],
                category: ScratchBlocks.Categories.motor,
                extensions: ["colours_motor", "shape_statement"]
            })
        }
    };

    ScratchBlocks.Blocks.motor_M5_SetServoMotor = {
        init: function () {
            this.jsonInit({
                message0: ScratchBlocks.Msg.M5_SetServoMotor,
                args0: [{
                    type: "field_dropdown",
                    name: "MOTORPORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT2, "2"],
                    ]
                }, {
                    type: "input_value",
                    name: "SPEED"
                }, {
                    type: "input_value",
                    name: "ANGLE"
                }],
                category: ScratchBlocks.Categories.motor,
                extensions: ["colours_motor", "shape_statement"]
            })
        }
    };


    ScratchBlocks.Blocks.motor_M5_WaitServomotor = {
        init: function () {
            this.jsonInit({
                message0: ScratchBlocks.Msg.M5_WaitServomotor,
                args0: [{
                    type: "field_dropdown",
                    name: "MOTORPORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT2, "2"],
                    ]
                }, {
                    type: "input_value",
                    name: "SPEED"
                }, {
                    type: "input_value",
                    name: "ANGLE"
                }],
                category: ScratchBlocks.Categories.motor,
                extensions: ["colours_motor", "shape_statement"]
            })
        }
    };


    ScratchBlocks.Blocks.motor_M5_SetMotorCode = {
        init: function () {
            this.jsonInit({
                message0: ScratchBlocks.Msg.M5_SetMotorCode,
                args0: [{
                    type: "field_dropdown",
                    name: "MOTORPORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT2, "2"],
                    ]
                }],
                category: ScratchBlocks.Categories.motor,
                extensions: ["colours_motor", "shape_statement"]
            })
        }
    };

    
    ScratchBlocks.Blocks.motor_M5_GetMotorCode = {
        init: function () {
            this.jsonInit({
                message0: ScratchBlocks.Msg.M5_GetMotorCode,
                args0: [{
                    type: "field_dropdown",
                    name: "MOTORPORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT2, "2"],
                    ]
                }],
                category: ScratchBlocks.Categories.motor,
                extensions: ["colours_motor", "output_number"]
            })
        }
    };

    ScratchBlocks.Blocks.sensor_M5_GetButton = {
        init: function () {
            this.jsonInit({
                message0: ScratchBlocks.Msg.M5_GetButton,
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"]
                    ]
                }],
                extensions: ["colours_sensor", "output_boolean"]
            })
        }
    };

    ScratchBlocks.Blocks.sensor_M5_GetLightSensor = {
        init: function () {
            this.jsonInit({
                message0: ScratchBlocks.Msg.M5_GetLightSensor,
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"]
                    ]
                }],
                extensions: ["colours_sensor", "output_number"]
            })
        }
    };


    ScratchBlocks.Blocks.sensor_M5_Set3CLed = {
        init: function () {
            this.jsonInit({
                message0: ScratchBlocks.Msg.M5_Set3CLed,
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"]
                    ]
                }, {
                    type: "field_dropdown",
                    name: "COLOR",
                    defaultItem: 3,
                    options: [
                        [ScratchBlocks.Msg.JMD_COLOR2, "1"], //red
                        [ScratchBlocks.Msg.JMD_COLOR3, "2"], //green
                        [ScratchBlocks.Msg.JMD_COLOR4, "3"], //blue
                        [ScratchBlocks.Msg.JMD_COLOR5, "4"], //yellow
                        [ScratchBlocks.Msg.JMD_COLOR6, "5"], //purple
                        [ScratchBlocks.Msg.JMD_COLOR7, "6"], //cyan
                        [ScratchBlocks.Msg.JMD_COLOR8, "7"], //white
                        [ScratchBlocks.Msg.JMD_COLOR9, "0"] //black
                    ]
                }],
                extensions: ["colours_sensor", "shape_statement"]
            })
        }
    };

    ScratchBlocks.Blocks.sensor_M5_GetMIC = {
        init: function () {
            this.jsonInit({
                message0: ScratchBlocks.Msg.M5_GetMIC,
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"]
                    ]
                }],
                extensions: ["colours_sensor", "output_number"]
            })
        }
    };

    ScratchBlocks.Blocks.sensor_M5_GetPotentiometer = {
        init: function () {
            this.jsonInit({
                message0: ScratchBlocks.Msg.M5_GetPotentiometer,
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"]
                    ]
                }],
                extensions: ["colours_sensor", "output_number"]
            })
        }
    };


    ScratchBlocks.Blocks.sensor_M5_GetTiltAxis = {
        init: function () {
            this.jsonInit({
                message0: ScratchBlocks.Msg.M5_GetTiltAxis,
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"]
                    ]
                }, {
                    type: "field_dropdown",
                    name: "AXIS",
                    options: [
                        ["X", "0"],
                        ["Y", "1"],
                        ["Z", "2"],
                    ]
                }],
                extensions: ["colours_sensor", "output_number"]
            })
        }
    };


    ScratchBlocks.Blocks.sensor_M5_GetUltrasonic = {
        init: function () {
            this.jsonInit({
                message0: ScratchBlocks.Msg.M5_GetUltrasonic,
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"]
                    ]
                }],
                extensions: ["colours_sensor", "output_number"]
            })
        }
    };


    ScratchBlocks.Blocks.sensor_M5_GetColorSensor = {
        init: function () {
            this.jsonInit({
                message0: ScratchBlocks.Msg.M5_GetColorSensor,
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"]
                    ]
                }],
                extensions: ["colours_sensor", "output_number"]
            })
        }
    };


    ScratchBlocks.Blocks.sensor_M5_GetPhotosensitive = {
        init: function () {
            this.jsonInit({
                message0: ScratchBlocks.Msg.M5_GetPhotosensitive,
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"]
                    ]
                }],
                extensions: ["colours_sensor", "output_number"]
            })
        }
    };

    ScratchBlocks.Blocks.sensor_M5_GetShortIRDist = {
        init: function () {
            this.jsonInit({
                message0: ScratchBlocks.Msg.M5_GetShortIRDist,
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"]
                    ]
                }],
                extensions: ["colours_sensor", "output_number"]
            })
        }
    };

    ScratchBlocks.Blocks.sensor_M5_GetRFID522 = {
        init: function () {
            this.jsonInit({
                message0: ScratchBlocks.Msg.M5_GetRFID522,
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"]
                    ]
                }],
                extensions: ["colours_sensor", "output_number"]
            })
        }
    };
    ScratchBlocks.Blocks.sensor_M5_ReadRFID522Card = {
        init: function () {
            this.jsonInit({
                message0: ScratchBlocks.Msg.M5_ReadRFID522Card,
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"]
                    ]
                }, {
                    type: "input_value",
                    name: "CARDNUMBER"
                }],
                extensions: ["colours_sensor", "output_number"]
            })
        }
    };

    ScratchBlocks.Blocks.sensor_M5_WriteRFID522Card = {
        init: function () {
            this.jsonInit({
                message0: ScratchBlocks.Msg.M5_WriteRFID522Card,
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"]
                    ]
                }, {
                    type: "input_value",
                    name: "CARDNUMBER"
                }, {
                    type: "input_value",
                    name: "DATA"
                }],
                extensions: ["colours_sensor", "shape_statement"]
            })
        }
    };

    ScratchBlocks.Blocks.wireless_M5_GetRFModuleRemoteButton = {
        init: function () {
            this.jsonInit({
                message0: ScratchBlocks.Msg.M5_GetRFModuleRemoteButton,
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"]
                    ]
                }],
                category: ScratchBlocks.Categories.wireless,
                extensions: ["colours_wireless", "output_number"]
            })
        }
    };

    ScratchBlocks.Blocks.wireless_M5_GetRFModuleRemoteCode = {
        init: function () {
            this.jsonInit({
                message0: ScratchBlocks.Msg.M5_GetRFModuleRemoteCode,
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"]
                    ]
                }],
                category: ScratchBlocks.Categories.wireless,
                extensions: ["colours_wireless", "output_number"]
            })
        }
    };
    ScratchBlocks.Blocks.wireless_M5_GetRFModuleRemoteRocker = {
        init: function () {
            this.jsonInit({
                message0: ScratchBlocks.Msg.M5_GetRFModuleRemoteRocker,
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"]
                    ]
                }, {
                    type: "field_dropdown",
                    name: 'DIRECTION',
                    options: [
                        [ScratchBlocks.Msg.JMD_LEFT, "0"],
                        [ScratchBlocks.Msg.JMD_RIGHT, "1"]
                    ]
                }, {
                    type: "field_dropdown",
                    name: 'AXIS',
                    options: [
                        [ScratchBlocks.Msg.JMD_X_AXIS, "0"],
                        [ScratchBlocks.Msg.JMD_Y_AXIS, "1"]
                    ]
                }],
                category: ScratchBlocks.Categories.wireless,
                extensions: ["colours_wireless", "output_number"]
            })
        }
    };

    ScratchBlocks.Blocks.wireless_M5_getBluetoothControl = {
        init: function () {
            this.jsonInit({
                message0: ScratchBlocks.Msg.WIRELESS_GET_BLUETOOTHCONTROL,
                category: ScratchBlocks.Categories.wireless,
                extensions: ["colours_wireless", "output_number"]
            })
        }
    };

    ScratchBlocks.Blocks.wireless_M5_getBluetoothControlData = {
        init: function () {
            this.jsonInit({
                message0: ScratchBlocks.Msg.WIRELESS_GET_BLUETOOTHCONTROLDATA,
                category: ScratchBlocks.Categories.wireless,
                extensions: ["colours_wireless", "output_number"]
            })
        }
    };


    ScratchBlocks.Blocks.show_M5_SetDisplayVar = {
        init: function () {
            this.jsonInit({
                message0: ScratchBlocks.Msg.M5_SetDisplayVar,
                args0: [{
                    type: "input_value",
                    name: "VALUE",
                }],
                category: ScratchBlocks.Categories.show,
                extensions: ["colours_show", "shape_statement"]
            })
        }
    };
    ScratchBlocks.Blocks.show_M5_SetDisplayExpression = {
        init: function () {
            this.jsonInit({
                message0: ScratchBlocks.Msg.M5_SetDisplayExpression,
                args0: [{
                    type: "field_dropdown",
                    name: "IMAGE",
                    options: [
                        [ScratchBlocks.Msg.M5_Patter_arg1, "1"],
                        [ScratchBlocks.Msg.M5_Patter_arg2, "2"],
                        [ScratchBlocks.Msg.M5_Patter_arg3, "3"],
                        [ScratchBlocks.Msg.M5_Patter_arg4, "4"],
                        [ScratchBlocks.Msg.M5_Patter_arg5, "5"],
                        [ScratchBlocks.Msg.M5_Patter_arg6, "6"],
                        [ScratchBlocks.Msg.M5_Patter_arg7, "7"],
                        [ScratchBlocks.Msg.M5_Patter_arg8, "8"],
                        [ScratchBlocks.Msg.M5_Patter_arg9, "9"],
                        [ScratchBlocks.Msg.M5_Patter_arg10, "10"],
                        [ScratchBlocks.Msg.M5_Patter_arg11, "11"],
                        [ScratchBlocks.Msg.M5_Patter_arg12, "12"],
                        [ScratchBlocks.Msg.M5_Patter_arg13, "13"],
                        [ScratchBlocks.Msg.M5_Patter_arg14, "14"],
                        [ScratchBlocks.Msg.M5_Patter_arg15, "15"]
                    ]
                }],
                category: ScratchBlocks.Categories.show,
                extensions: ["colours_show", "shape_statement"]
            })
        }
    };


    ScratchBlocks.Blocks.jmd_M5_GetSysButton = {
        init: function () {
            this.jsonInit({
                message0: ScratchBlocks.Msg.M5_GetSysButton,
                args0: [{
                    type: "field_dropdown",
                    name: "BUTTON",
                    options: [
                        [ScratchBlocks.Msg.M5_Left_btn, "2"],
                        [ScratchBlocks.Msg.M5_right_btn, "3"]
                    ]
                }],
                category: ScratchBlocks.Categories.jmd,
                extensions: ["colours_jmd", "output_boolean"]
            })
        }
    };

    ScratchBlocks.Blocks.control_forever_system = {
        init: function () {
            this.jsonInit({
                message0: ScratchBlocks.Msg.M5_forever,
                message1: "%1",
                message2: "%1",
                lastDummyAlign2: "RIGHT",
                args0: [{
                    type: "input_value",
                    name: "SYSTEM",
                    check: "Boolean"
                }],
                args1: [{
                    type: "input_statement",
                    name: "SUBSTACK"
                }],
                args2: [{
                    type: "field_image",
                    src: ScratchBlocks.mainWorkspace.options.pathToMedia + "repeat.svg",
                    width: 24,
                    height: 24,
                    alt: "*",
                    flip_rtl: !0
                }],
                category: ScratchBlocks.Categories.control,
                extensions: ["colours_control", "shape_end"]
            })
        }
    };

    ScratchBlocks.Blocks.jmd_M5_System = {
        init: function () {
            this.jsonInit({
                message0: "RCU",
                category: ScratchBlocks.Categories.jmd,
                extensions: ["colours_jmd", "output_boolean"]
            })
        }
    };


    ScratchBlocks.Blocks.show_getIsTouch = {
        init: function () {
            this.jsonInit({
                message0: "屏幕被触摸?",
                category: ScratchBlocks.Categories.show,
                extensions: ["colours_show", "output_boolean"]
            })
        }
    };
    ScratchBlocks.Blocks.show_getTouchScreenX = {
        init: function () {
            this.jsonInit({
                // message0: "%1 %2",
                // args0: [{
                //     type: "field_image",
                //     src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/E6/show_icon.svg",
                //     width: 30,
                //     height: 26

                // }, {
                //     type: "field_vertical_separator"
                // }],
                message0: ScratchBlocks.Msg.SHOW_GET_TOUCHSCREENX,
                category: ScratchBlocks.Categories.show,
                extensions: ["colours_show", "output_number"]
            })
        }
    };
    ScratchBlocks.Blocks.show_getTouchScreenY = {
        init: function () {
            this.jsonInit({
                // message0: "%1 %2",
                // args0: [{
                //     type: "field_image",
                //     src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/E6/show_icon.svg",
                //     width: 30,
                //     height: 26

                // }, {
                //     type: "field_vertical_separator"
                // }],
                message0: ScratchBlocks.Msg.SHOW_GET_TOUCHSCREENY,
                category: ScratchBlocks.Categories.show,
                extensions: ["colours_show", "output_number"]
            })
        }
    };








    ScratchBlocks.Blocks.operator_strToNum = {
        init: function () {
            this.jsonInit({
                message0: ScratchBlocks.Msg.OPERATORS_STRINGTONUMBER,
                args0: [{
                    type: "input_value",
                    name: "STRING"
                }],
                category: ScratchBlocks.Categories.operators,
                extensions: ["colours_operators", "output_number"]
            })
        }
    };
    ScratchBlocks.Blocks.operator_numToStr = {
        init: function () {
            this.jsonInit({
                message0: ScratchBlocks.Msg.OPERATORS_NUMBERTOSTRING,
                args0: [{
                    type: "input_value",
                    name: "NUM"
                }],
                category: ScratchBlocks.Categories.operators,
                extensions: ["colours_operators", "output_number"]
            })
        }
    };

    ScratchBlocks.Blocks.show_M6SetLCDBack = {
        init: function () {
            this.jsonInit({
                // message0: "%1 %2",
                // args0: [{
                //     type: "field_image",
                //     src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/E6/show_icon.svg",
                //     width: 30,
                //     height: 26

                // }, {
                //     type: "field_vertical_separator"
                // }],
                message0: ScratchBlocks.Msg.SHOW_M6SetLCDBack,
                args0: [{
                    type: "field_dropdown",
                    name: "STATUS",
                    options: [
                        [ScratchBlocks.Msg.SHOW_ARG_M6SetLCDBack_OFF, "0"],
                        [ScratchBlocks.Msg.SHOW_ARG_M6SetLCDBack_ON, "1"]
                    ]
                }],
                category: ScratchBlocks.Categories.show,
                extensions: ["colours_show", "shape_statement"]
            })
        }
    };


    ScratchBlocks.Blocks.M6_motor_setServoMotor = {
        init: function () {
            this.jsonInit({
                // message0: "%1 %2",
                // args0: [{
                //     type: "field_image",
                //     src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/E6/motor_icon.svg",
                //     width: 30,
                //     height: 26

                // }, {
                //     type: "field_vertical_separator"
                // }],
                message0: ScratchBlocks.Msg.MOTOR_M6_setServoMotor,
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT4, "4"]
                    ]
                }, {
                    type: "input_value",
                    name: "SPEED"
                }, {
                    type: "input_value",
                    name: "ANGLE"
                }],
                category: ScratchBlocks.Categories.motor,
                extensions: ["colours_motor", "shape_statement"]
            })
        }
    };

    ScratchBlocks.Blocks.M6_motor_waitservomotor = {
        init: function () {
            this.jsonInit({
                // message0: "%1 %2",
                // args0: [{
                //     type: "field_image",
                //     src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/E6/motor_icon.svg",
                //     width: 30,
                //     height: 26

                // }, {
                //     type: "field_vertical_separator"
                // }],
                message0: ScratchBlocks.Msg.MOTOR_M6_waitservomotor,
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_MOTOR_PORT4, "4"]
                    ]
                }, {
                    type: "input_value",
                    name: "SPEED"
                }, {
                    type: "input_value",
                    name: "ANGLE"
                }],
                category: ScratchBlocks.Categories.motor,
                extensions: ["colours_motor", "shape_statement"]
            })
        }
    };



    ScratchBlocks.Blocks.control_RunPython = {
        init: function () {
            this.jsonInit({
                message0: ScratchBlocks.Msg.control_RunPython,
                args0: [{
                    type: "input_value",
                    name: "COMMAND"
                }],
                category: ScratchBlocks.Categories.motor,
                extensions: ["colours_control", "shape_statement"]
            })
        }
    };


    ScratchBlocks.Blocks.sensor_getUltrasonicCompare = {
        init: function () {
            this.jsonInit({
                // message0: "%1 %2",
                // args0: [{
                //     type: "field_image",
                //     src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/E6/chao_shen_bo.svg",
                //     width: 30,
                //     height: 26

                // }, {
                //     type: "field_vertical_separator"
                // }],
                message0: ScratchBlocks.Msg.SENSOR_GET_ULTRASONICCOMPARE,
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "MODE",
                    options: [
                        ["<", "<"],
                        [">", ">"],
                        ["=", "=="]
                    ]
                }, {
                    type: "input_value",
                    name: "DATA"
                }],
                extensions: ["colours_sensor", "output_boolean"]
            })
        }
    };


    ScratchBlocks.Blocks.sensor_colorDetectionCompare = {
        init: function () {
            this.jsonInit({
                // message0: "%1 %2",
                // args0: [{
                //     type: "field_image",
                //     src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/E6/RGB.svg",
                //     width: 30,
                //     height: 26

                // }, {
                //     type: "field_vertical_separator"
                // }],
                message0: ScratchBlocks.Msg.SENSOR_GET_colorDetectionCompare,
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "MODE",
                    options: [
                        [ScratchBlocks.Msg.SENSOR_ARG_ULTRASONICCOMPARE_RED, "1"],
                        [ScratchBlocks.Msg.SENSOR_ARG_ULTRASONICCOMPARE_GREEN, "2"],
                        [ScratchBlocks.Msg.SENSOR_ARG_colorDetectionCompare_BLUE, "3"],
                        [ScratchBlocks.Msg.SENSOR_ARG_colorDetectionCompare_YELLOW, "4"],
                        [ScratchBlocks.Msg.SENSOR_ARG_colorDetectionCompare_BLACK, "5"],
                        [ScratchBlocks.Msg.SENSOR_ARG_colorDetectionCompare_WHITE, "6"],
                    ]
                }],
                extensions: ["colours_sensor", "output_boolean"]
            })
        }
    };


    ScratchBlocks.Blocks.sensor_colorDetectionMode = {
        init: function () {
            this.jsonInit({
                // message0: "%1 %2",
                // args0: [{
                //     type: "field_image",
                //     src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/E6/RGB.svg",
                //     width: 30,
                //     height: 26

                // }, {
                //     type: "field_vertical_separator"
                // }],
                message0: ScratchBlocks.Msg.SENSOR_GET_colorDetectionMode,
                args0: [{
                    type: "field_dropdown",
                    name: "PORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"],
                    ]
                }, {
                    type: "field_dropdown",
                    name: "MODE",
                    options: [
                        [ScratchBlocks.Msg.SENSOR_ARG_colorDetectionMode_GVALUE, "1"],
                        [ScratchBlocks.Msg.SENSOR_ARG_colorDetectionMode_RVALUE, "2"],
                        [ScratchBlocks.Msg.SENSOR_ARG_colorDetectionMode_BVALUE, "3"],
                        [ScratchBlocks.Msg.SENSOR_ARG_colorDetectionMode_LIGHT, "9"],
                        [ScratchBlocks.Msg.SENSOR_ARG_colorDetectionMode_TONE, "15"],
                        [ScratchBlocks.Msg.SENSOR_ARG_colorDetectionMode_SATURATION, "16"],
                        [ScratchBlocks.Msg.SENSOR_ARG_colorDetectionMode_BRIGHTNESS, "17"],
                    ]
                }],
                extensions: ["colours_sensor", "output_number"]
            })
        }
    };




    ScratchBlocks.Blocks.sensor_setLightSensor = {
        init: function () {
            this.jsonInit({
                // message0: "%1 %2",
                // args0: [{
                //     type: "field_image",
                //     src: ScratchBlocks.mainWorkspace.options.pathToMedia + "menuIcons/E6/guang_dian.svg",
                //     width: 30,
                //     height: 26

                // }, {
                //     type: "field_vertical_separator"
                // }],
                message0: ScratchBlocks.Msg.SENSOR_SETLIGHTSENSOR,
                args0: [{
                    type: "field_dropdown",
                    name: "SENSORPORT",
                    options: [
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT1, "1"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT2, "2"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT3, "3"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT4, "4"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT5, "5"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT6, "6"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT7, "7"],
                        [ScratchBlocks.Msg.JMD_SENSOR_PORT8, "8"]
                    ]
                }, {
                    type: "field_dropdown",
                    name: "STATE",
                    options: [
                        [ScratchBlocks.Msg.JMD_LIGHTOFF, "0"],
                        [ScratchBlocks.Msg.JMD_LIGHTON, "1"]
                    ]
                }],
                colour: ScratchBlocks.Colours.sensor.secondary,
                colourSecondary: ScratchBlocks.Colours.sensor.secondary,
                colourTertiary: ScratchBlocks.Colours.sensor.tertiary,
                category: ScratchBlocks.Categories.sensor,
                extensions: ["colours_sensor", "shape_statement"]
            })
        }
    };


    // pid控制器
    ScratchBlocks.PIDCategory = function (workspace) {
        var pidModelLists = workspace.getVariablesOfType('PID');
        var xmlList = [];
        ScratchBlocks.PIDCategory.addCreateButton(xmlList, workspace)
        if (pidModelLists.length > 0) {

            ScratchBlocks.PIDCategory.addPidSetPidControler(xmlList, pidModelLists[0])
            ScratchBlocks.PIDCategory.addPidSetPidControlerFork(xmlList, pidModelLists[0])
            ScratchBlocks.PIDCategory.addPidGetPidControlResult(xmlList, pidModelLists[0])
        }
        return xmlList
    }
    ScratchBlocks.PIDCategory.addCreateButton = function (xmlList, workspace, type) {
        var button = document.createElement('button');
        // Set default msg, callbackKey, and callback values for type 'VARIABLE'
        // var msg = ScratchBlocks.Msg.NEW_VARIABLE;
        // var callbackKey = 'CREATE_VARIABLE';
        // var callback = function (button) {
        //     ScratchBlocks.Variables.createVariable(button.getTargetWorkspace(), null, '');
        // };
        var msg = ScratchBlocks.Msg.NEW_PID;
        var callbackKey = 'CREATE_PID';
        var callback = function (button) {
            ScratchBlocks.Variables.createVariable(button.getTargetWorkspace(), null, 'PID');
        };
        button.setAttribute('text', msg);
        button.setAttribute('callbackKey', callbackKey);
        workspace.registerButtonCallback(callbackKey, callback);
        xmlList.push(button);
    };
    ScratchBlocks.PIDCategory.addPidSetPidControler = function (xmlList, variable) {
        // <block type="pid_getPidControlResult_list">
        //   <value name="PID">
        //    <shadow type="data_variablemenu"></shadow>
        //   </value>
        //   <value name="VALUE">
        //     <shadow type="math_number">
        //       <field name="NUM">1</field>
        //     </shadow>
        //   </value>
        // </block>
        ScratchBlocks.PIDCategory.addBlock(xmlList, variable, 'pid_setPidControler',
            'PID', ['TARGET', 'math_number', 1], ['VALUE', 'math_number', 1]);
    };

    ScratchBlocks.PIDCategory.addPidSetPidControlerFork = function (xmlList, variable) {
        // <block type="pid_getPidControlResult_list">
        //   <value name="PID">
        //    <shadow type="data_variablemenu"></shadow>
        //   </value>
        //   <value name="VALUE">
        //     <shadow type="math_number">
        //       <field name="NUM">1</field>
        //     </shadow>
        //   </value>
        // </block>
        ScratchBlocks.PIDCategory.addBlock(xmlList, variable, 'pid_setPidControlerFork',
            'PID', ['KP', 'math_number', 1], ['KI', 'math_number', 1], ['KD', 'math_number', 1]);
    };

    ScratchBlocks.PIDCategory.addPidGetPidControlResult = function (xmlList, variable) {
        // <block type="pid_getPidControlResult">
        //   <value name="PID">
        //    <shadow type="data_variablemenu"></shadow>
        //   </value>
        // </block>
        ScratchBlocks.PIDCategory.addBlock(xmlList, variable, 'pid_getPidControlResult', 'PID');
    };
    ScratchBlocks.PIDCategory.addBlock = function (xmlList, variable, blockType,
        fieldName, opt_value, opt_secondValue, opt_secondValue_Two, opt_secondValue_three) {
        if (ScratchBlocks.Blocks[blockType]) {
            var firstValueField;
            var secondValueField;
            var secondValueFieldTwo;
            var secondValueFieldThree;
            if (opt_value) {
                firstValueField = ScratchBlocks.PIDCategory.createValue(opt_value[0],
                    opt_value[1], opt_value[2]);
            }
            if (opt_secondValue) {
                secondValueField = ScratchBlocks.PIDCategory.createValue(opt_secondValue[0],
                    opt_secondValue[1], opt_secondValue[2]);
            }
            if (opt_secondValue_Two) {
                secondValueFieldTwo = ScratchBlocks.PIDCategory.createValue(opt_secondValue_Two[0],
                    opt_secondValue_Two[1], opt_secondValue_Two[2]);
            }
            if (opt_secondValue_three) {
                secondValueFieldThree = ScratchBlocks.PIDCategory.createValue(opt_secondValue_three[0],
                    opt_secondValue_three[1], opt_secondValue_three[2]);
            }

            var gap = 8;
            var blockText = '<xml>' +
                '<block type="' + blockType + '" gap="' + gap + '">' +
                ScratchBlocks.Variables.generateVariableFieldXml_(variable, fieldName) +
                firstValueField + secondValueField + secondValueFieldTwo + secondValueFieldThree +
                '</block>' +
                '</xml>';
            var block = ScratchBlocks.Xml.textToDom(blockText).firstChild;
            xmlList.push(block);
        }
    };
    ScratchBlocks.PIDCategory.createValue = function (valueName, type, value) {
        var fieldName;
        switch (valueName) {
            case 'ITEM':
                fieldName = 'TEXT';
                break;
            case 'INDEX':
                fieldName = 'NUM';
                break;
            case 'VALUE':
                if (type === 'math_number') {
                    fieldName = 'NUM';
                } else {
                    fieldName = 'TEXT';
                }
                break;
            default:
                if (type === 'math_number') {
                    fieldName = 'NUM';
                } else {
                    fieldName = 'TEXT';
                }
                break;
        }
        var valueField =
            '<value name="' + valueName + '">' +
            '<shadow type="' + type + '">' +
            '<field name="' + fieldName + '">' + value + '</field>' +
            '</shadow>' +
            '</value>';
        return valueField;
    };

    let DataCategory = ScratchBlocks.DataCategory
    ScratchBlocks.DataCategory = function (workspace) {
        let robotType = "E6"
        if (vm.editingTarget) {
            robotType = vm.editingTarget.robotType
        }

        var variableModelList = workspace.getVariablesOfType('');
        variableModelList.sort(ScratchBlocks.VariableModel.compareByName);
        var xmlList = [];

        ScratchBlocks.DataCategory.addCreateButton(xmlList, workspace, 'VARIABLE');

        for (var i = 0; i < variableModelList.length; i++) {
            ScratchBlocks.DataCategory.addDataVariable(xmlList, variableModelList[i]);
        }

        if (variableModelList.length > 0) {
            xmlList[xmlList.length - 1].setAttribute('gap', 24);
            var firstVariable = variableModelList[0];

            ScratchBlocks.DataCategory.addSetVariableTo(xmlList, firstVariable);
            ScratchBlocks.DataCategory.addChangeVariableBy(xmlList, firstVariable);
            ScratchBlocks.DataCategory.addShowVariable(xmlList, firstVariable);
            ScratchBlocks.DataCategory.addHideVariable(xmlList, firstVariable);
        }

        // Now add list variables to the flyout
        ScratchBlocks.DataCategory.addCreateButton(xmlList, workspace, 'LIST');
        variableModelList = workspace.getVariablesOfType(ScratchBlocks.LIST_VARIABLE_TYPE);
        variableModelList.sort(ScratchBlocks.VariableModel.compareByName);
        for (var i = 0; i < variableModelList.length; i++) {
            ScratchBlocks.DataCategory.addDataList(xmlList, variableModelList[i]);
        }

        if (variableModelList.length > 0) {
            xmlList[xmlList.length - 1].setAttribute('gap', 24);
            var firstVariable = variableModelList[0];

            if (robotType == "E7") {
                ScratchBlocks.DataCategory.addSetList(xmlList, firstVariable);
            }

            ScratchBlocks.DataCategory.addAddToList(xmlList, firstVariable);
            ScratchBlocks.DataCategory.addSep(xmlList);
            ScratchBlocks.DataCategory.addDeleteOfList(xmlList, firstVariable);
            ScratchBlocks.DataCategory.addDeleteAllOfList(xmlList, firstVariable);
            ScratchBlocks.DataCategory.addInsertAtList(xmlList, firstVariable);
            ScratchBlocks.DataCategory.addReplaceItemOfList(xmlList, firstVariable);
            ScratchBlocks.DataCategory.addSep(xmlList);
            ScratchBlocks.DataCategory.addItemOfList(xmlList, firstVariable);
            ScratchBlocks.DataCategory.addItemNumberOfList(xmlList, firstVariable);
            ScratchBlocks.DataCategory.addLengthOfList(xmlList, firstVariable);
            ScratchBlocks.DataCategory.addListContainsItem(xmlList, firstVariable);
            ScratchBlocks.DataCategory.addSep(xmlList);
            ScratchBlocks.DataCategory.addShowList(xmlList, firstVariable);
            ScratchBlocks.DataCategory.addHideList(xmlList, firstVariable);
        }
        if (robotType == "E7") {
            var pidModelLists = workspace.getVariablesOfType('PID');
            ScratchBlocks.PIDCategory.addCreateButton(xmlList, workspace)
            if (pidModelLists.length > 0) {

                ScratchBlocks.PIDCategory.addPidSetPidControler(xmlList, pidModelLists[0])
                ScratchBlocks.PIDCategory.addPidSetPidControlerFork(xmlList, pidModelLists[0])
                ScratchBlocks.PIDCategory.addPidGetPidControlResult(xmlList, pidModelLists[0])
            }
        }

        return xmlList;
    };
    ScratchBlocks.DataCategory.addSetList = function (xmlList, variable) {
        // <block type="data_setlist">
        //   <field name="LIST" variabletype="list" id="">variablename</field>
        //   <value name="ITEM">
        //     <shadow type="text">
        //       <field name="TEXT"></field>
        //     </shadow>
        //   </value>
        // </block>
        ScratchBlocks.DataCategory.addBlock(xmlList, variable, 'data_setlist',
            'LIST', ['VALUE', 'text', '']);
    };
    ScratchBlocks.DataCategory.addDataVariable = DataCategory.addDataVariable
    ScratchBlocks.DataCategory.addSetVariableTo = DataCategory.addSetVariableTo
    ScratchBlocks.DataCategory.addChangeVariableBy = DataCategory.addChangeVariableBy
    ScratchBlocks.DataCategory.addShowVariable = DataCategory.addShowVariable
    ScratchBlocks.DataCategory.addHideVariable = DataCategory.addHideVariable
    ScratchBlocks.DataCategory.addDataList = DataCategory.addDataList
    ScratchBlocks.DataCategory.addAddToList = DataCategory.addAddToList
    ScratchBlocks.DataCategory.addDeleteOfList = DataCategory.addDeleteOfList
    ScratchBlocks.DataCategory.addDeleteAllOfList = DataCategory.addDeleteAllOfList
    ScratchBlocks.DataCategory.addInsertAtList = DataCategory.addInsertAtList
    ScratchBlocks.DataCategory.addReplaceItemOfList = DataCategory.addReplaceItemOfList
    ScratchBlocks.DataCategory.addItemOfList = DataCategory.addItemOfList
    ScratchBlocks.DataCategory.addItemNumberOfList = DataCategory.addItemNumberOfList
    ScratchBlocks.DataCategory.addLengthOfList = DataCategory.addLengthOfList
    ScratchBlocks.DataCategory.addListContainsItem = DataCategory.addListContainsItem
    ScratchBlocks.DataCategory.addShowList = DataCategory.addShowList
    ScratchBlocks.DataCategory.addHideList = DataCategory.addHideList
    ScratchBlocks.DataCategory.addCreateButton = DataCategory.addCreateButton
    ScratchBlocks.DataCategory.addBlock = DataCategory.addBlock
    ScratchBlocks.DataCategory.createValue = DataCategory.createValue
    ScratchBlocks.DataCategory.addSep = DataCategory.addSep

    E7Blocks(ScratchBlocks)

    toPython(ScratchBlocks)
    toC(ScratchBlocks)
    toPythonDebug(ScratchBlocks)



    return ScratchBlocks;
}
